webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _shared = __webpack_require__(10);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _gameSessionController = __webpack_require__(292);
	
	var _gameSessionController2 = _interopRequireDefault(_gameSessionController);
	
	var _gamePageController = __webpack_require__(348);
	
	var _gamePageController2 = _interopRequireDefault(_gamePageController);
	
	var _gameSessionMessage = __webpack_require__(227);
	
	var _gameSessionMessage2 = _interopRequireDefault(_gameSessionMessage);
	
	var _creditsDialog = __webpack_require__(345);
	
	var _creditsDialog2 = _interopRequireDefault(_creditsDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 2019-09-09 (10:50).
	 */
	var log = __webpack_require__(5)();
	
	
	var headerHtml = __webpack_require__(801);
	var GameViews = __webpack_require__(461);
	
	// Styles
	__webpack_require__(762);
	
	$(function () {
	  _shared2.default.shouldSetUpCreditsDialog = false;
	
	  _shared2.default.init();
	  SeriousGame.init();
	});
	
	var SeriousGame = {};
	
	(function (SeriousGame) {
	  var gamePageController = void 0;
	  var gameSessionController = void 0;
	
	  var $header = void 0;
	
	  var creditsDialog = void 0;
	
	  var joinSessionView = void 0;
	  var introductionView = void 0;
	  var quizView = void 0;
	  var businessModelView = void 0;
	  var reconnectView = void 0;
	
	  var currentGameView = void 0;
	
	  var gameSessionId = null;
	  var teamName = null;
	
	  var gameSession = void 0;
	  var caseWrapper = void 0;
	  var roundOverview = void 0;
	  var endGameData = void 0;
	
	  var pathSessionId = null;
	
	  var canReconnect = false;
	  var isWaitingToReconnect = false;
	  var reconnectAttempts = 0;
	
	  // Will be set to false when client gets 'shouldClose' param from server, otherwise true
	  var shouldReconnect = true;
	
	  SeriousGame.init = function () {
	    var pathSection2 = _utils2.default.getPathSection(2);
	
	    if (pathSection2 === "sessionid") {
	      pathSessionId = _utils2.default.getPathSection(3);
	    }
	
	    var websocketProtocol = window.location.protocol.includes("https") ? "wss:" : "ws:";
	
	    gameSessionController = new _gameSessionController2.default({
	      baseUrl: websocketProtocol + "//" + window.location.host + "/services/1.0/realtime/gamesession/"
	    });
	
	    gameSessionController.addEventListener("session-opened", onSessionOpened);
	    gameSessionController.addEventListener("session-closed", onSessionClosed);
	    gameSessionController.addEventListener("session-error", onSessionError);
	    gameSessionController.addEventListener("session-message", onSessionMessage);
	
	    setUpHeader();
	    setUpViews();
	    setGamePageController();
	
	    renderCreditsDialog();
	    setUpEventListeners();
	  };
	
	  function setUpHeader() {
	    $header = $(headerHtml);
	    $("#game-view-header").append($header);
	    _languageManager2.default.applyLocale($header);
	  }
	
	  function setUpViews() {
	    joinSessionView = createGameView("session-join", { sessionId: pathSessionId });
	    introductionView = createGameView("introduction");
	    quizView = createGameView("quiz");
	    businessModelView = createGameView("business-model");
	    reconnectView = createGameView("reconnect");
	
	    joinSessionView.onJoinSession = function (element) {
	      gameSessionId = this.getFormSessionId();
	      teamName = this.getFormTeamName();
	
	      if (_utils2.default.isNotNull(teamName)) {
	        teamName = teamName.trim();
	      }
	
	      joinSession(gameSessionId, teamName);
	    };
	
	    introductionView.onIntroductionCompleted = function (skipped) {
	      log.info("Introduction complete (skipped? %s)", skipped);
	      introductionView.setLoadingState(true);
	      var message = _gameSessionMessage2.default.createRequest("introductionCompleted", null, { skipped: skipped });
	      gameSessionController.sendMessage(message);
	    };
	
	    quizView.onQuestionAnswered = function (index, isCorrect) {
	      log.info("Sending answer request to server: Question [%d] answered - correct ? %s", index, isCorrect);
	
	      var data = {
	        index: index,
	        isCorrect: isCorrect
	      };
	
	      var message = _gameSessionMessage2.default.createRequest("quizQuestionAnswered", null, data);
	      gameSessionController.sendMessage(message);
	    };
	
	    businessModelView.onRenderCompleted = function () {
	      if (roundOverview.currentRoundData.roundIndex === 1 && _utils2.default.isNull(roundOverview.currentRoundData.closed)) {
	        this.showTutorialDialog();
	      }
	    };
	
	    businessModelView.onInvestmentAdded = function (investment, extraProductId) {
	      log.info("Sending purchase request to server for investment [%s]", investment.type);
	
	      var data = {
	        investmentKey: investment.key,
	        extraProductKey: extraProductId
	      };
	
	      var message = _gameSessionMessage2.default.createRequest("businessModelInvestment", null, data);
	      gameSessionController.sendMessage(message);
	    };
	
	    businessModelView.onTeamClosedRound = function () {
	      log.info("Sending close round request to server");
	
	      var message = _gameSessionMessage2.default.createRequest("businessModelRoundClosed", null, null);
	      gameSessionController.sendMessage(message);
	    };
	
	    businessModelView.onTeamRequestedLoan = function () {
	      log.info("Sending close round request to server");
	
	      var message = _gameSessionMessage2.default.createRequest("requestLoan", null, null);
	      gameSessionController.sendMessage(message);
	    };
	
	    businessModelView.onTeamOverviewChanged = function (teamEndData) {
	      log.info("Changing team endgame overview to [%s]", teamEndData.teamName);
	      SeriousGame.setPageTitle(teamEndData.teamName);
	    };
	
	    businessModelView.onTeamOverviewClosed = function () {
	      log.info("Closed team endgame overview, changing title");
	      SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.score"));
	    };
	
	    reconnectView.onCancelReconnect = function () {
	      joinSessionView.setJoinButtonLoading(false);
	      joinSessionView.showForm();
	
	      gamePageController.changePage(joinSessionView);
	    };
	  }
	
	  function setGamePageController() {
	    var gameViews = [];
	
	    gameViews.push(joinSessionView);
	    gameViews.push(introductionView);
	    gameViews.push(quizView);
	    gameViews.push(businessModelView);
	    gameViews.push(reconnectView);
	
	    gamePageController = new _gamePageController2.default({
	      basePath: "/game",
	      gameViews: gameViews,
	      defaultView: joinSessionView,
	      initialPage: "/game/session-join",
	      onBeforePageChange: onBeforePageChange,
	      onContentShow: onContentShow
	    });
	
	    gamePageController.init();
	  }
	
	  function renderCreditsDialog() {
	    if (_utils2.default.isNotNull(creditsDialog)) {
	      creditsDialog.destroy();
	    }
	
	    creditsDialog = new _creditsDialog2.default({
	      onCancel: function onCancel() {
	        if (currentGameView.key === "business-model") {
	          businessModelView.setActionBarLayer(false);
	        }
	
	        currentGameView.removeBackdrop();
	        creditsDialog.hide();
	      }
	    });
	
	    creditsDialog.create();
	  }
	
	  function createGameView(key, options) {
	    var fileKey = "./" + key + ".js";
	    if (GameViews.keys().includes(fileKey)) {
	      var GameViewClass = GameViews(fileKey);
	
	      return new GameViewClass(_extends({
	        key: key,
	        container: "#game-view-wrapper",
	        gameSessionController: gameSessionController
	      }, options));
	    } else {
	      log.error("Couldn't find game view [%s]", key);
	    }
	  }
	
	  function onBeforePageChange(gameView) {
	    log.info("On before page change - game view: %o", gameView);
	
	    // Boolean determines if page change is allowed or not
	    return true;
	  }
	
	  function onContentShow(gameView) {
	    log.info("On content show - game view: %o", gameView);
	
	    if (_utils2.default.isNotNull(gameView)) {
	      currentGameView = gameView;
	
	      if (gameView.key === joinSessionView.key) {
	        SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.default"));
	        SeriousGame.hideRoundsBreadcrumb();
	      } else if (gameView.key === introductionView.key) {
	        SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.introduction"));
	        SeriousGame.hideRoundsBreadcrumb();
	      } else if (gameView.key === quizView.key) {
	        var _teamName = gameSession && gameSession.team ? gameSession.team.name : _languageManager2.default.getValueForKey("serious_game.page_title.default");
	        SeriousGame.setPageTitle(_teamName);
	        SeriousGame.showRoundsBreadcrumb("quiz");
	        SeriousGame.setRoundBreadcrumbActive(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
	        quizView.setCurrentQuestion(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
	      } else if (gameView.key === businessModelView.key) {
	        var _teamName2 = gameSession && gameSession.team ? gameSession.team.name : _languageManager2.default.getValueForKey("serious_game.page_title.default");
	        SeriousGame.setPageTitle(_teamName2);
	        SeriousGame.showRoundsBreadcrumb();
	        // Note: round index goes from 0 to 5 (0 = quiz) so subtract 1 to only match the actual "game" rounds to the breadcrumb indexes
	        SeriousGame.setRoundBreadcrumbActive(roundOverview.currentRoundData.roundIndex - 1);
	      } else {
	        SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.default"));
	        SeriousGame.hideRoundsBreadcrumb();
	      }
	
	      gameView.show();
	    }
	  }
	
	  SeriousGame.setPageTitle = function (title) {
	    $("#page-title").text(title);
	  };
	
	  SeriousGame.showRoundsBreadcrumb = function (labelType) {
	    var $roundsBreadcrumb = $("#rounds-breadcrumb");
	
	    var labelKey = labelType === "quiz" ? "serious_game.rounds_breadcrumb.labels.quiz" : "serious_game.rounds_breadcrumb.labels.business_model";
	
	    $roundsBreadcrumb.find(".breadcrumb__label").text(_languageManager2.default.getValueForKey(labelKey));
	    $roundsBreadcrumb.show();
	  };
	
	  SeriousGame.hideRoundsBreadcrumb = function () {
	    $("#rounds-breadcrumb").hide();
	  };
	
	  SeriousGame.setRoundBreadcrumbActive = function (round) {
	    $("#rounds-breadcrumb").find(".round-breadcrumb__item").each(function (index, el) {
	      var $el = $(el).removeClass("active");
	
	      if (round === index) {
	        $el.addClass("active");
	      }
	    });
	  };
	
	  function joinSession(sessionId, teamName) {
	    gameSessionController.sessionId = sessionId;
	    gameSessionController.teamName = teamName;
	    gameSessionController.init();
	    gameSessionController.connect();
	  }
	
	  function onSessionOpened(e) {
	    log.debug("Session opened - %o", e);
	
	    canReconnect = true;
	    shouldReconnect = true;
	
	    joinSessionView.setJoinButtonLoading(false);
	    joinSessionView.showLoadingState();
	  }
	
	  function onSessionClosed(e) {
	    log.debug("Session closed - %o", e);
	
	    if (shouldReconnect) {
	      reconnect({ retryCount: 3 });
	    } else {
	      joinSessionView.setJoinButtonLoading(false);
	      joinSessionView.showForm();
	      gamePageController.changePage(joinSessionView);
	    }
	  }
	
	  function onSessionError(e) {
	    log.debug("Session error: %o", e);
	    reconnect({ retryCount: 3 });
	  }
	
	  function onSessionMessage(e) {
	    log.debug("Session message: %o", e);
	    handleMessage(e);
	  }
	
	  function reconnect(options) {
	    if (!shouldReconnect) return;
	    if (_utils2.default.isNull(options)) options = {};
	
	    if (_utils2.default.isNull(gameSessionController) || _utils2.default.isNull(gameSessionController.sessionId) || _utils2.default.isNull(gameSessionController.teamName)) {
	      gamePageController.changePage(joinSessionView);
	      return;
	    }
	
	    var retryCount = options.retryCount;
	    var timeBetweenAttempts = options.timeBetweenAttempts || 3 * 1000;
	    shouldReconnect = false;
	
	    if (canReconnect) {
	      // Reconnect can only happen when you were connected before, meaning 'canReconnect' is only set to true once connected
	      canReconnect = false;
	      reconnectAttempts = 0;
	
	      shouldReconnect = true;
	
	      reconnectView.clearReconnectResult();
	      gamePageController.changePage(reconnectView);
	    } else if (!options.skipTimeout && !isWaitingToReconnect) {
	      log.info("Waiting for %dms before attempting another reconnect", timeBetweenAttempts);
	
	      isWaitingToReconnect = true;
	
	      setTimeout(function () {
	        isWaitingToReconnect = false;
	        reconnect({ retryCount: retryCount, skipTimeout: true, force: true });
	      }, timeBetweenAttempts);
	
	      return;
	    }
	
	    // Prevents that more than 1 reconnect attempt is running at the same time (canReconnect is immediately set to 'false' and maximum 1 reconnect timeout can run at any given time)
	    if (shouldReconnect || options.force) {
	      reconnectAttempts++;
	
	      log.info("Trying to reconnect to game session '%s' for team '%s'\nReconnect attempts: %d / %d", gameSessionId, teamName, reconnectAttempts, retryCount);
	
	      if (_utils2.default.isNumber(retryCount) && reconnectAttempts <= retryCount) {
	        gameSessionController.connect();
	      } else {
	        // Show message
	        reconnectView.setReconnectFailed();
	
	        setTimeout(function () {
	          joinSessionView.setJoinButtonLoading(false);
	          joinSessionView.showForm();
	
	          gamePageController.changePage(joinSessionView);
	        }, 3000);
	      }
	    }
	  }
	
	  function handleMessage(event) {
	    if (_utils2.default.isNotNull(event) && _utils2.default.isNotNull(event.data)) {
	      var message = _utils2.default.parseJSON(event.data, true);
	
	      log.info("Message data - %o", message);
	
	      if (_utils2.default.isNotNull(message)) {
	        switch (message.type) {
	          case "request":
	            handleMessageRequest(message);
	            break;
	          case "response":
	            handleMessageResponse(message);
	            break;
	          case "error":
	            handleMessageError(message);
	            break;
	        }
	      }
	    }
	  }
	
	  function handleMessageRequest(message) {
	    if (_utils2.default.isNotNull(message)) {
	      switch (message.service) {
	        case "closeConnection":
	          handleCloseConnectionRequest(message);
	          break;
	
	        case "gameSessionJoined":
	          // This session successfully joined the game session
	          handleSessionJoined(message);
	          break;
	        case "teamJoined":
	          // A team (different from this team) joined the game session
	          handleTeamJoined(message);
	          break;
	        case "teamRemoved":
	          // A team has been removed from the game session
	          handleTeamRemoved(message);
	          break;
	        case "startGame":
	          // Teacher started the game session
	          handleSessionStarted(message);
	          break;
	        case "allTeamsFinishedQuiz":
	          // All teams finished the quiz --> show result screen
	          handleQuizFinished(message);
	          break;
	        case "startNextRound":
	          handleRoundStarted(message);
	          break;
	        // Message when another team has ended their round so we can update information
	        case "teamEndedRound":
	        case "teamEndedRoundByTeacher":
	          handleTeamEndedRound(message);
	          break;
	        // Message when teacher has closed the round instead of the team itself
	        case "teacherEndedRound":
	          handleTeacherEndedRound(message);
	          break;
	
	        case "reloadedData":
	          handleReloadedData(message);
	          break;
	        case "gameFinished":
	          handleGameFinished(message);
	          break;
	      }
	    }
	  }
	
	  function handleMessageResponse(message) {
	    if (_utils2.default.isNotNull(message)) {
	      switch (message.service) {
	        case "introductionEndRegistered":
	          handleIntroductionEndRegistered(message);
	          break;
	        case "answerRegistered":
	          handleAnswerRegistered(message);
	          break;
	        case "investmentRegistered":
	          handleInvestmentRegistered(message);
	          break;
	        case "roundEndRegistered":
	          handleRoundEndRegistered(message);
	          break;
	        case "loanRegistered":
	          handleLoanRegistered(message);
	          break;
	      }
	    }
	  }
	
	  function handleMessageError(message) {
	    if (_utils2.default.isNotNull(message)) {
	      if (_utils2.default.isNotNull(message.params)) {
	        var messageKey = "errors.websocket." + message.error + ".message";
	        var messageText = _languageManager2.default.getValueForKey(messageKey);
	
	        if (messageKey !== messageText) {
	          if (_utils2.default.isNotNull(currentGameView) && currentGameView.key === "session-join") {
	            // Show error message in 'session-join' form
	            joinSessionView.setFormError(messageText);
	            joinSessionView.setJoinButtonLoading(false);
	            joinSessionView.showForm();
	          } else {
	            // Show error message in dialog
	          }
	        }
	
	        if (message.params["shouldClose"] === "true") {
	          shouldReconnect = false;
	          gameSessionController.disconnect();
	        } else {
	          reconnect({ retryCount: 3 });
	        }
	      }
	    }
	  }
	
	  function goToCurrentView() {
	    if (gameSession.status === "created") {
	      gamePageController.changePage(joinSessionView);
	      joinSessionView.showLoadingState();
	    } else if (gameSession.status === "playing") {
	      if (_utils2.default.isNotNull(roundOverview.currentRoundData)) {
	        if (roundOverview.currentRoundData.roundIndex === 0) {
	          if (roundOverview.commonDataSelf.quizResult.currentQuizQuestion === 0) {
	            gamePageController.changePage(introductionView);
	          } else {
	            gamePageController.changePage(quizView);
	
	            var quizFinished = true;
	            for (var i = 0; i < roundOverview.commonTeamData.length; i++) {
	              if (_utils2.default.isNull(roundOverview.commonTeamData[i].state.currentRoundClosed)) {
	                quizFinished = false;
	                break;
	              }
	            }
	
	            if (quizFinished) {
	              quizView.showScoreScreen({
	                currentTeam: gameSession.team,
	                roundOverview: roundOverview,
	                roundIndex: 0
	              });
	
	              SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.score"));
	            } else if (_utils2.default.isNotNull(roundOverview.currentRoundData.closed)) {
	              quizView.showWaitingScreen();
	            } else {
	              quizView.hideScoreScreen();
	            }
	          }
	        } else {
	          var wasAlreadyOnBusinessModel = currentGameView.key === businessModelView.key;
	
	          if (!wasAlreadyOnBusinessModel) {
	            gamePageController.changePage(businessModelView);
	          }
	
	          if (_utils2.default.isNotNull(roundOverview.currentRoundData.closed)) {
	            SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.score"));
	            businessModelView.showScoreScreen({
	              currentTeam: gameSession.team,
	              roundOverview: roundOverview,
	              asOverlay: false,
	              keepVisible: true
	            });
	          } else {
	            if (wasAlreadyOnBusinessModel) {
	              // Note: quickfix ... need to go back to business model view if we are on 'waiting room score screen', otherwise we are stuck and have to refresh
	              if (businessModelView.scoreScreen.isOpen() && businessModelView.$scoreScreenContainer.hasClass("bm__background-filled")) {
	                businessModelView.showBusinessModel(true, true);
	              }
	            } else {
	              businessModelView.showBusinessModel(true, true);
	            }
	          }
	        }
	      } else {
	        gamePageController.changePage(introductionView);
	      }
	    } else if (gameSession.status === "finished") {
	      gamePageController.changePage(businessModelView);
	      businessModelView.showEndGameView(endGameData);
	    }
	  }
	
	  function extractInitialData(message) {
	    caseWrapper = message.data.caseWrapper;
	    gameSession = message.data.gameSession;
	    endGameData = message.data.endGameData;
	
	    extractRoundOverview(message.data.roundOverview);
	  }
	
	  function extractRoundOverview(data) {
	    roundOverview = data;
	    extractCommonDataSelf(roundOverview.commonTeamData);
	  }
	
	  function extractCommonDataSelf(commonTeamData) {
	    roundOverview.commonDataSelf = null;
	
	    if (_utils2.default.isNotNull(commonTeamData)) {
	      for (var i = 0; i < commonTeamData.length; i++) {
	        if (commonTeamData[i].teamName === gameSession.team.name) {
	          roundOverview.commonDataSelf = commonTeamData[i];
	          break;
	        }
	      }
	    }
	  }
	
	  function extractQuizResult(message) {
	    roundOverview.commonDataSelf.quizResult = message.data;
	  }
	
	  function reloadData(message) {
	    extractInitialData(message);
	
	    businessModelView.caseWrapper = caseWrapper;
	    businessModelView.gameSession = gameSession;
	    businessModelView.team = gameSession.team;
	    businessModelView.setRoundOverview(roundOverview);
	
	    introductionView.videoLink = caseWrapper.caseObj.movie;
	    quizView.gameSession = gameSession;
	    quizView.questions = caseWrapper.questions;
	    quizView.currentQuestion = roundOverview.commonDataSelf.quizResult.currentQuizQuestion;
	
	    // TODO validate data??
	    goToCurrentView();
	  }
	
	  function handleCloseConnectionRequest(message) {
	    log.info("Server requested to close connection for game session [%s] and team [%s]", gameSessionId, teamName);
	    shouldReconnect = false;
	    gameSessionController.disconnect();
	  }
	
	  function handleSessionJoined(message) {
	    log.info("Successfully joined game session [%s] with team name [%s]\nGameSession: %o\nCase: %o", gameSessionId, teamName, gameSession, caseWrapper);
	    reloadData(message);
	  }
	
	  function handleTeamJoined(message) {
	    var newTeam = message.data.teamName;
	
	    log.info("Team [%s] joined game session (session count: %d)", newTeam, message.data.sessionCount);
	
	    if (_utils2.default.isNull(gameSession.teamList)) gameSession.teamList = [];
	
	    if (!gameSession.teamList.includes(newTeam)) {
	      gameSession.teamList.push(newTeam);
	    }
	  }
	
	  function handleTeamRemoved(message) {
	    var removedTeam = message.data.teamName;
	
	    log.info("Team [%s] removed from game session", removedTeam);
	
	    if (_utils2.default.isNotNull(gameSession.teamList) && gameSession.teamList.includes(removedTeam)) {
	      for (var i = 0; i < gameSession.teamList.length; i++) {
	        if (gameSession.teamList[i] === removedTeam) {
	          gameSession.teamList.splice(i, 1);
	          break;
	        }
	      }
	
	      if (_utils2.default.isNotNull(quizView)) {
	        quizView.updateTeamList(gameSession.teamList);
	      }
	
	      if (_utils2.default.isNotNull(businessModelView)) {
	        businessModelView.updateTeamList(gameSession.teamList);
	      }
	    }
	  }
	
	  function handleSessionStarted(message) {
	    log.info("Session started - going to introduction");
	
	    extractInitialData(message);
	
	    quizView.currentQuestion = roundOverview.commonDataSelf.quizResult.currentQuizQuestion;
	
	    gamePageController.changePage(introductionView);
	  }
	
	  function handleQuizFinished(message) {
	    log.info("All teams finished the quiz - %o", message);
	
	    roundOverview.commonTeamData = message.data.commonTeamData;
	    extractCommonDataSelf(roundOverview.commonTeamData);
	
	    quizView.showScoreScreen({
	      currentTeam: gameSession.team,
	      roundOverview: roundOverview,
	      roundIndex: 0 // quiz
	    });
	    SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.score"));
	  }
	
	  function handleRoundStarted(message) {
	    log.info("Teacher started the next round");
	
	    extractRoundOverview(message.data);
	
	    var currentRoundData = roundOverview.currentRoundData;
	    SeriousGame.setPageTitle(gameSession.team.name);
	
	    if (gameSession.team.roundData.hasOwnProperty(currentRoundData.roundIndex)) {
	      gameSession.team.roundData[currentRoundData.roundIndex] = currentRoundData;
	
	      if (currentGameView.key !== businessModelView.key) {
	        gamePageController.changePage(businessModelView);
	      }
	
	      SeriousGame.setRoundBreadcrumbActive(roundOverview.currentRoundData.roundIndex - 1);
	      businessModelView.setRoundOverview(roundOverview);
	      businessModelView.showBusinessModel(true);
	
	      var subsidyResult = _utils2.default.isNotNull(message.params) ? message.params.subsidyResult : null;
	      showStartRoundDialogs(subsidyResult);
	    } else {
	      log.error("Unable to find round data for round [%d]", currentRoundData.roundIndex);
	    }
	  }
	
	  function showStartRoundDialogs(subsidyResult) {
	    // Show:
	    //    event dialog --> subsidy dialog --> loan dialog (if one is not needed, skip to the next one)
	
	    var showLoanDialog = void 0;
	    var showSubsidyDialog = void 0;
	    var showEventDialog = void 0;
	
	    if (roundOverview.currentRoundData.canLoan && roundOverview.currentRoundData.loaned > 0) {
	      if (roundOverview.currentRoundData.loaned > 0) {
	        showLoanDialog = function showLoanDialog() {
	          return businessModelView.showLoanDialog("auto-loan", true, businessModelView.pulsateLoanButton.bind(businessModelView));
	        };
	      } else {
	        showLoanDialog = function showLoanDialog() {
	          return businessModelView.showLoanDialog("optional-loan", true, businessModelView.pulsateLoanButton.bind(businessModelView));
	        };
	      }
	    }
	
	    if (_utils2.default.isNotNull(subsidyResult)) {
	      showSubsidyDialog = function showSubsidyDialog() {
	        businessModelView.showInvestmentExtra("subsidy", {
	          subsidyApproved: subsidyResult === "approved"
	        }, true, showLoanDialog);
	      };
	    }
	
	    if (_utils2.default.isNotNull(roundOverview.currentEvent)) {
	      showEventDialog = function showEventDialog() {
	        businessModelView.pulsateEventButton();
	        businessModelView.showEventDialog(true, showSubsidyDialog || showLoanDialog);
	      };
	    }
	
	    if (_utils2.default.isNotNull(showEventDialog)) showEventDialog();else if (_utils2.default.isNotNull(showSubsidyDialog)) showSubsidyDialog();else if (_utils2.default.isNotNull(showLoanDialog)) showLoanDialog();
	  }
	
	  function handleIntroductionEndRegistered(message) {
	    extractRoundOverview(message.data);
	
	    introductionView.setLoadingState(false);
	
	    gamePageController.changePage(quizView);
	    quizView.setCurrentQuestion(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
	    SeriousGame.setRoundBreadcrumbActive(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
	
	    if (roundOverview.commonDataSelf.quizResult.quizCompleted) {
	      if (roundOverview.commonDataSelf.quizResult.allTeamsDone) {
	        quizView.showScoreScreen({
	          currentTeam: gameSession.team,
	          roundOverview: roundOverview,
	          roundIndex: 0 // quiz
	        });
	      } else {
	        quizView.showWaitingScreen();
	      }
	    }
	  }
	
	  function handleAnswerRegistered(message) {
	    log.info("Answer registered successfully");
	
	    extractQuizResult(message);
	
	    quizView.setCurrentQuestion(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
	    SeriousGame.setRoundBreadcrumbActive(roundOverview.commonDataSelf.quizResult.currentQuizQuestion);
	
	    if (roundOverview.commonDataSelf.quizResult.quizCompleted) {
	      quizView.showWaitingScreen();
	    }
	  }
	
	  function handleInvestmentRegistered(message) {
	    log.info("Investment purchase registered successfully");
	
	    extractRoundOverview(message.data.roundOverview);
	
	    gameSession.team.roundData[roundOverview.currentRoundData.roundIndex] = roundOverview.currentRoundData;
	
	    if (currentGameView.key !== businessModelView.key) {
	      gamePageController.changePage(businessModelView);
	    }
	
	    businessModelView.gameSession = gameSession;
	    businessModelView.team = gameSession.team;
	    businessModelView.setRoundOverview(roundOverview);
	    // Also hides investment dialog ( + set btn loading to false) and investment slider
	    businessModelView.showBusinessModel(true, true);
	
	    if (_utils2.default.isNotNull(message.data.circularBonus)) {
	      businessModelView.showGameBonusDialog(message.data.circularBonus.type, message.data.circularBonus.value);
	    }
	  }
	
	  function handleRoundEndRegistered(message) {
	    log.info("Round end registered successfully");
	
	    extractRoundOverview(message.data);
	
	    SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.score"));
	    businessModelView.setRoundOverview(roundOverview);
	    businessModelView.showScoreScreen({
	      asOverlay: false
	    });
	  }
	
	  function handleLoanRegistered(message) {
	    log.info("Loan was registered successfully");
	
	    extractRoundOverview(message.data);
	    businessModelView.setRoundOverview(roundOverview);
	    businessModelView.showBusinessModel(true, true);
	  }
	
	  function handleTeamEndedRound(message) {
	    log.info("Team [%s] ended its current round", message.data.teamName);
	
	    roundOverview.commonTeamData = message.data.commonTeamData;
	    extractCommonDataSelf(roundOverview.commonTeamData);
	    businessModelView.setRoundOverview(roundOverview);
	  }
	
	  function handleTeacherEndedRound(message) {
	    // Same as when team would end the round, but instead it's the teacher who forced the team to close the round
	    log.info("Round end registered successfully");
	
	    extractRoundOverview(message.data);
	
	    SeriousGame.setPageTitle(_languageManager2.default.getValueForKey("serious_game.page_title.score"));
	    businessModelView.setRoundOverview(roundOverview);
	    businessModelView.showScoreScreen({
	      asOverlay: false
	    });
	  }
	
	  function handleReloadedData(message) {
	    log.info("Data has been reloaded for game session [%s]\nGameSession: %o\nCase: %o", gameSessionId, gameSession, caseWrapper);
	    reloadData(message);
	  }
	
	  function handleGameFinished(message) {
	    log.info("All teams have closed the last round - game is finished");
	    endGameData = message.data;
	    businessModelView.showEndGameView(endGameData);
	  }
	
	  function setUpEventListeners() {
	    $("#header-circonopoly-brand").off("click").on("click", function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (_utils2.default.isNotNull(creditsDialog)) {
	        if (currentGameView.key === "business-model") {
	          businessModelView.showBusinessModel(true, true);
	          businessModelView.setActionBarLayer(true);
	        }
	
	        currentGameView.showBackdrop();
	        creditsDialog.show();
	      }
	    });
	  }
	})(SeriousGame);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./arrow.svg": 249,
		"./background.png": 250,
		"./background.svg": 251,
		"./crossing.svg": 252,
		"./electricity-big.svg": 253,
		"./electricity-pylon.svg": 254,
		"./electricity-small.svg": 255
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 224;


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./collection_grey.svg": 256,
		"./collection_white.svg": 257,
		"./company_grey.svg": 258,
		"./company_white.svg": 259,
		"./composting_grey.svg": 260,
		"./composting_white.svg": 261,
		"./factory2_white.svg": 262,
		"./factory_grey.svg": 263,
		"./factory_white.svg": 264,
		"./limited_resources_grey.svg": 265,
		"./limited_resources_white.svg": 266,
		"./own_channel_grey.svg": 267,
		"./own_channel_white.svg": 268,
		"./plus.svg": 269,
		"./product_service_system.svg": 270,
		"./recycling_grey.svg": 271,
		"./recycling_white.svg": 272,
		"./repair_service_grey.svg": 273,
		"./repair_service_white.svg": 274,
		"./reusability.svg": 275,
		"./stores_grey.svg": 276,
		"./stores_white.svg": 277,
		"./unlimited_resources_bio_white.svg": 278,
		"./unlimited_resources_grey.svg": 279,
		"./unlimited_resources_white.svg": 280,
		"./users_grey.svg": 281,
		"./users_white.svg": 282,
		"./waste_grey.svg": 283,
		"./waste_white.svg": 284
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 225;


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 59,
		"./af.js": 59,
		"./ar": 66,
		"./ar-dz": 60,
		"./ar-dz.js": 60,
		"./ar-kw": 61,
		"./ar-kw.js": 61,
		"./ar-ly": 62,
		"./ar-ly.js": 62,
		"./ar-ma": 63,
		"./ar-ma.js": 63,
		"./ar-sa": 64,
		"./ar-sa.js": 64,
		"./ar-tn": 65,
		"./ar-tn.js": 65,
		"./ar.js": 66,
		"./az": 67,
		"./az.js": 67,
		"./be": 68,
		"./be.js": 68,
		"./bg": 69,
		"./bg.js": 69,
		"./bm": 70,
		"./bm.js": 70,
		"./bn": 71,
		"./bn.js": 71,
		"./bo": 72,
		"./bo.js": 72,
		"./br": 73,
		"./br.js": 73,
		"./bs": 74,
		"./bs.js": 74,
		"./ca": 75,
		"./ca.js": 75,
		"./cs": 76,
		"./cs.js": 76,
		"./cv": 77,
		"./cv.js": 77,
		"./cy": 78,
		"./cy.js": 78,
		"./da": 79,
		"./da.js": 79,
		"./de": 82,
		"./de-at": 80,
		"./de-at.js": 80,
		"./de-ch": 81,
		"./de-ch.js": 81,
		"./de.js": 82,
		"./dv": 83,
		"./dv.js": 83,
		"./el": 84,
		"./el.js": 84,
		"./en-SG": 85,
		"./en-SG.js": 85,
		"./en-au": 86,
		"./en-au.js": 86,
		"./en-ca": 87,
		"./en-ca.js": 87,
		"./en-gb": 88,
		"./en-gb.js": 88,
		"./en-ie": 89,
		"./en-ie.js": 89,
		"./en-il": 90,
		"./en-il.js": 90,
		"./en-nz": 91,
		"./en-nz.js": 91,
		"./eo": 92,
		"./eo.js": 92,
		"./es": 95,
		"./es-do": 93,
		"./es-do.js": 93,
		"./es-us": 94,
		"./es-us.js": 94,
		"./es.js": 95,
		"./et": 96,
		"./et.js": 96,
		"./eu": 97,
		"./eu.js": 97,
		"./fa": 98,
		"./fa.js": 98,
		"./fi": 99,
		"./fi.js": 99,
		"./fo": 100,
		"./fo.js": 100,
		"./fr": 103,
		"./fr-ca": 101,
		"./fr-ca.js": 101,
		"./fr-ch": 102,
		"./fr-ch.js": 102,
		"./fr.js": 103,
		"./fy": 104,
		"./fy.js": 104,
		"./ga": 105,
		"./ga.js": 105,
		"./gd": 106,
		"./gd.js": 106,
		"./gl": 107,
		"./gl.js": 107,
		"./gom-latn": 108,
		"./gom-latn.js": 108,
		"./gu": 109,
		"./gu.js": 109,
		"./he": 110,
		"./he.js": 110,
		"./hi": 111,
		"./hi.js": 111,
		"./hr": 112,
		"./hr.js": 112,
		"./hu": 113,
		"./hu.js": 113,
		"./hy-am": 114,
		"./hy-am.js": 114,
		"./id": 115,
		"./id.js": 115,
		"./is": 116,
		"./is.js": 116,
		"./it": 118,
		"./it-ch": 117,
		"./it-ch.js": 117,
		"./it.js": 118,
		"./ja": 119,
		"./ja.js": 119,
		"./jv": 120,
		"./jv.js": 120,
		"./ka": 121,
		"./ka.js": 121,
		"./kk": 122,
		"./kk.js": 122,
		"./km": 123,
		"./km.js": 123,
		"./kn": 124,
		"./kn.js": 124,
		"./ko": 125,
		"./ko.js": 125,
		"./ku": 126,
		"./ku.js": 126,
		"./ky": 127,
		"./ky.js": 127,
		"./lb": 128,
		"./lb.js": 128,
		"./lo": 129,
		"./lo.js": 129,
		"./lt": 130,
		"./lt.js": 130,
		"./lv": 131,
		"./lv.js": 131,
		"./me": 132,
		"./me.js": 132,
		"./mi": 133,
		"./mi.js": 133,
		"./mk": 134,
		"./mk.js": 134,
		"./ml": 135,
		"./ml.js": 135,
		"./mn": 136,
		"./mn.js": 136,
		"./mr": 137,
		"./mr.js": 137,
		"./ms": 139,
		"./ms-my": 138,
		"./ms-my.js": 138,
		"./ms.js": 139,
		"./mt": 140,
		"./mt.js": 140,
		"./my": 141,
		"./my.js": 141,
		"./nb": 142,
		"./nb.js": 142,
		"./ne": 143,
		"./ne.js": 143,
		"./nl": 145,
		"./nl-be": 144,
		"./nl-be.js": 144,
		"./nl.js": 145,
		"./nn": 146,
		"./nn.js": 146,
		"./pa-in": 147,
		"./pa-in.js": 147,
		"./pl": 148,
		"./pl.js": 148,
		"./pt": 150,
		"./pt-br": 149,
		"./pt-br.js": 149,
		"./pt.js": 150,
		"./ro": 151,
		"./ro.js": 151,
		"./ru": 152,
		"./ru.js": 152,
		"./sd": 153,
		"./sd.js": 153,
		"./se": 154,
		"./se.js": 154,
		"./si": 155,
		"./si.js": 155,
		"./sk": 156,
		"./sk.js": 156,
		"./sl": 157,
		"./sl.js": 157,
		"./sq": 158,
		"./sq.js": 158,
		"./sr": 160,
		"./sr-cyrl": 159,
		"./sr-cyrl.js": 159,
		"./sr.js": 160,
		"./ss": 161,
		"./ss.js": 161,
		"./sv": 162,
		"./sv.js": 162,
		"./sw": 163,
		"./sw.js": 163,
		"./ta": 164,
		"./ta.js": 164,
		"./te": 165,
		"./te.js": 165,
		"./tet": 166,
		"./tet.js": 166,
		"./tg": 167,
		"./tg.js": 167,
		"./th": 168,
		"./th.js": 168,
		"./tl-ph": 169,
		"./tl-ph.js": 169,
		"./tlh": 170,
		"./tlh.js": 170,
		"./tr": 171,
		"./tr.js": 171,
		"./tzl": 172,
		"./tzl.js": 172,
		"./tzm": 174,
		"./tzm-latn": 173,
		"./tzm-latn.js": 173,
		"./tzm.js": 174,
		"./ug-cn": 175,
		"./ug-cn.js": 175,
		"./uk": 176,
		"./uk.js": 176,
		"./ur": 177,
		"./ur.js": 177,
		"./uz": 179,
		"./uz-latn": 178,
		"./uz-latn.js": 178,
		"./uz.js": 179,
		"./vi": 180,
		"./vi.js": 180,
		"./x-pseudo": 181,
		"./x-pseudo.js": 181,
		"./yo": 182,
		"./yo.js": 182,
		"./zh-cn": 183,
		"./zh-cn.js": 183,
		"./zh-hk": 184,
		"./zh-hk.js": 184,
		"./zh-tw": 185,
		"./zh-tw.js": 185
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 247;


/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 286:
285,

/***/ 287:
285,

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./biomaterials.svg": 427,
		"./extraproduct.svg": 428,
		"./greenenergy.svg": 429,
		"./localproduction.svg": 430,
		"./paas.svg": 431,
		"./productredesign.svg": 432,
		"./renewablematerials.svg": 433,
		"./repairservice.svg": 434,
		"./residualflows.svg": 435,
		"./returnprogram.svg": 436,
		"./reuse.svg": 437,
		"./sloticon.svg": 438,
		"./solarpanels.svg": 439,
		"./spareparts.svg": 440,
		"./subsidy.svg": 441,
		"./wastevalorization.svg": 442
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 288;


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./energy.svg": 443,
		"./subsidy.svg": 444,
		"./tax.svg": 445,
		"./tradewar.svg": 446
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 289;


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	__webpack_require__(339);
	
	var _investmentSlider = __webpack_require__(794);
	
	var _investmentSlider2 = _interopRequireDefault(_investmentSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-25 (10:20).
	 */
	__webpack_require__(323);
	__webpack_require__(322);
	
	var log = __webpack_require__(5)();
	
	
	var iconCardsReq = __webpack_require__(288);
	
	__webpack_require__(321);
	__webpack_require__(738);
	
	var InvestmentSlider = function () {
	  function InvestmentSlider(options) {
	    _classCallCheck(this, InvestmentSlider);
	
	    this.$container = $(options.container);
	    this.$element = null;
	
	    this.hasRendered = false;
	
	    this.team = options.team;
	    this._roundOverview = options.roundOverview;
	    this.hasRedesign = _utils2.default.isNotNull(this.roundOverview) ? this.currentRoundData.hasRedesign === true : false;
	    this.hasUnlimitedResources = _utils2.default.isNotNull(this.roundOverview) ? this.currentRoundData.hasUnlimitedResources === true : false;
	
	    this.investments = options.investments;
	
	    this.hideAnimationTimeout = null;
	
	    this.onInvestmentClicked = options.onInvestmentClicked;
	  }
	
	  _createClass(InvestmentSlider, [{
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	
	      this.$element = $(_investmentSlider2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.renderSlider();
	
	      this.setUpEventListeners();
	    }
	  }, {
	    key: "renderSlider",
	    value: function renderSlider() {
	      try {
	        var $slider = this.$element.find(".investments__slider");
	        var slickInitialized = $slider.hasClass("slick-initialized");
	
	        if (slickInitialized) {
	          // Remove all slides
	          // $slider.slick("slickRemove", null, null, true);
	          // Just temporarily remove slick and then add it back in later
	          $slider.slick("unslick");
	          $slider.empty();
	        }
	
	        for (var i = 0; i < this.investments.length; i++) {
	          var investment = this.investments[i];
	          var isLocked = investment.redesignNeeded && !this.hasRedesign || investment.type === "biomaterials" && !this.hasUnlimitedResources;
	          var purchaseCount = InvestmentSlider.getInvestmentPurchaseCount(this.team, this.roundOverview, investment);
	          var alreadyPurchased = false;
	
	          if (investment.type === "subsidy") {
	            alreadyPurchased = this.roundOverview.currentRoundData.subsidyApproved;
	          } else {
	            alreadyPurchased = purchaseCount > 0;
	          }
	
	          // log.debug("Adding investment card for investment - %o", investment);
	
	          var $investmentCardWrapper = $("<div class='ic__wrapper'></div>");
	
	          var $investmentCard = $("<div class='investment-card investment-card__front'></div>");
	          $investmentCard.attr("data-investment-key", investment.key);
	          $investmentCard.attr("data-investment-type", investment.type);
	          $investmentCard.attr("data-investment-category", investment.category);
	          $investmentCard.addClass("ic__type-" + investment.type);
	
	          if (isLocked) {
	            $investmentCard.addClass("ic-locked");
	          }
	
	          if (alreadyPurchased) {
	            $investmentCard.addClass("ic-purchased");
	          }
	
	          var $cardTop = $("<div class='investment-card__top'></div>");
	
	          var $investmentCost = $("<div class='ic__cost'></div>");
	          // NOTE: cost "-1" means that the cost == current round
	          var investmentCost = InvestmentSlider.getCostForInvestment(this.roundOverview, investment);
	          var $investmentCostValue = $("<div class='ic-data ic-data__budget'></div>");
	
	          if (investment.cost === -1) {
	            $investmentCost.addClass("ic__dynamic-cost");
	            $investmentCostValue.append("<span class='ic__dynamic-cost-label'>R</span>").append("<span class=\"ic__dynamic-cost-value\">" + investmentCost + "</span>");
	          } else {
	            $investmentCostValue.text(investmentCost);
	          }
	
	          $investmentCost.append($investmentCostValue);
	
	          if (investment.redesignNeeded) {
	            $investmentCost.append("<div class='ic-data ic-data__research'></div>");
	          }
	
	          $investmentCost.append("<div class='ic__cost-label'>" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.cost.label") + "</div>");
	          $cardTop.append($investmentCost);
	
	          var $investmentIcon = $("<div class='ic__icon'></div>").html(InvestmentSlider.getIconCardForInvestment(investment.type, isLocked));
	
	          var $iconWrapper = $("<div class='ic__icon-wrapper'></div>");
	          $iconWrapper.append($investmentIcon);
	
	          $cardTop.append($iconWrapper);
	
	          // $cardTop.append(`<h5 class='ic__title'>${utils.escapeHtml(investment.title)}</h5>`);
	          var investmentTitle = _languageManager2.default.getValueForKey("serious_game.business_model.investments.front.titles." + investment.type);
	          $cardTop.append("<h5 class='ic__title'>" + investmentTitle + "</h5>");
	
	          var summary = _utils2.default.escapeHtml(investment.summary);
	
	          if (isLocked) {
	            if (investment.type === "biomaterials") {
	              summary = _languageManager2.default.getValueForKey("serious_game.business_model.investments.front.locked.unlimited_resources.description");
	            } else {
	              summary = _languageManager2.default.getValueForKey("serious_game.business_model.investments.front.locked.product_redesign.description");
	            }
	          }
	
	          $cardTop.append("<p class='ic__description'>" + summary + "</p>");
	
	          var $cardBottom = $("<div class='investment-card__bottom'></div>");
	
	          var $investmentYield = $("<div class='ic__yield'></div>");
	          $investmentYield.append("<h6 class='ic__yield-label'>" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.yield.label") + "</h6>");
	
	          var approvalTime = 0;
	
	          if (["subsidy"].includes(investment.type)) {
	            approvalTime = 1;
	          }
	
	          var $approvalNote = $("<div class=\"ic__approval-time\">" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.approval") + "</div>");
	
	          if (approvalTime === 0) {
	            $approvalNote.addClass("visibility-hidden");
	          }
	
	          $investmentYield.append($approvalNote);
	
	          var $investmentYieldIcons = $("<div class='ic__yield-icons'></div>");
	          $investmentYieldIcons.append("<div class='ic-data ic-data__points'>" + investment.points + "</div>");
	
	          var incomeWithSign = investment.income > 0 ? "+" + investment.income : investment.income;
	          var incomeText = investment.type === "subsidy" ? investment.income : incomeWithSign;
	
	          $investmentYieldIcons.append("<div class='ic-data ic-data__income'>" + incomeText + "</div>");
	          $investmentYield.append($investmentYieldIcons);
	          $cardBottom.append($investmentYield);
	
	          $investmentCard.append($cardTop).append($cardBottom);
	          $investmentCardWrapper.append($investmentCard);
	
	          /*if(slickInitialized)
	          {
	            $slider.slick("slickAdd", $investmentCardWrapper);
	          }
	          else
	          {
	            $slider.append($investmentCardWrapper);
	          }*/
	
	          $slider.append($investmentCardWrapper);
	        }
	
	        // if(!slickInitialized)
	        // {
	        //   this.setUpSlick();
	        // }
	
	        this.setUpSlick();
	
	        // $slider.slick("slickGoTo", 1);
	        this.setUpInvestmentCardClickListener();
	      } catch (e) {
	        log.error("Failed to render investment slider - %o", e);
	      }
	    }
	  }, {
	    key: "updateData",
	    value: function updateData() {
	      for (var i = 0; i < this.investments.length; i++) {
	        var investment = this.investments[i];
	        var isLocked = investment.redesignNeeded && !this.hasRedesign || investment.type === "biomaterials" && !this.hasUnlimitedResources;
	        var purchaseCount = InvestmentSlider.getInvestmentPurchaseCount(this.team, this.roundOverview, investment);
	        var alreadyPurchased = false;
	
	        if (investment.type === "subsidy") {
	          alreadyPurchased = this.roundOverview.currentRoundData.subsidyApproved;
	        } else {
	          alreadyPurchased = purchaseCount > 0;
	        }
	
	        var $investmentCard = this.$element.find(".investment-card[data-investment-key='" + investment.key + "']");
	
	        if (isLocked) {
	          $investmentCard.addClass("ic-locked");
	        } else {
	          $investmentCard.removeClass("ic-locked");
	        }
	
	        if (alreadyPurchased) {
	          $investmentCard.addClass("ic-purchased");
	        } else {
	          $investmentCard.removeClass("ic-purchased");
	        }
	
	        var investmentCost = InvestmentSlider.getCostForInvestment(this.roundOverview, investment);
	
	        if (investment.cost === -1) {
	          $investmentCard.find(".ic__cost").addClass("ic__dynamic-cost");
	          $investmentCard.find(".ic-data.ic-data__budget").empty().append("<span class='ic__dynamic-cost-label'>R</span>").append("<span class=\"ic__dynamic-cost-value\">" + investmentCost + "</span>");
	        } else {
	          $investmentCard.find(".ic-data.ic-data__budget").text(investmentCost);
	        }
	
	        var summary = _utils2.default.escapeHtml(investment.summary);
	
	        if (isLocked) {
	          if (investment.type === "biomaterials") {
	            summary = _languageManager2.default.getValueForKey("serious_game.business_model.investments.front.locked.unlimited_resources.description");
	          } else {
	            summary = _languageManager2.default.getValueForKey("serious_game.business_model.investments.front.locked.product_redesign.description");
	          }
	        }
	
	        $investmentCard.find(".ic__icon").html(InvestmentSlider.getIconCardForInvestment(investment.type, isLocked));
	        $investmentCard.find(".investment-card__top .ic__description").html(summary);
	
	        $investmentCard.find(".ic-data.ic-data__points").html(investment.points);
	
	        var incomeWithSign = investment.income > 0 ? "+" + investment.income : investment.income;
	        var incomeText = investment.type === "subsidy" ? investment.income : incomeWithSign;
	
	        $investmentCard.find(".ic-data.ic-data__income").html(incomeText);
	      }
	
	      var category = this.$element.find(".category-tab-btn.category-active").data("investment-category");
	      this.applyFilter(category);
	    }
	  }, {
	    key: "setUpSlick",
	    value: function setUpSlick() {
	      var $slider = this.$element.find(".investments__slider");
	
	      $slider.slick({
	        centerMode: true,
	        focusOnSelect: false,
	        centerPadding: "40px",
	
	        mobileFirst: true,
	
	        draggable: false,
	        swipe: true,
	        infinite: true,
	
	        // dots: true,
	        arrows: true,
	        prevArrow: this.$element.find(".investment-slider__arrow-prev"),
	        nextArrow: this.$element.find(".investment-slider__arrow-next"),
	
	        slidesToShow: 1,
	        slidesToScroll: 1,
	
	        // Without this, adding slides after the initialize is fcked up for some reason:
	        // https://github.com/kenwheeler/slick/commit/be0d17cc858fb30e6a4d6b28cc29860c7170040d#comments
	        rows: 0,
	
	        // Note breakpoints is actually (breakpoint - 1)
	        responsive: [{
	          breakpoint: 575,
	          settings: {
	            centerMode: true,
	            centerPadding: "85px",
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 767,
	          settings: {
	            centerMode: true,
	            centerPadding: "150px",
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 899,
	          settings: {
	            centerMode: true,
	            centerPadding: "220px",
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 1023,
	          settings: {
	            centerMode: true,
	            centerPadding: "320px",
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }, {
	          breakpoint: 1349,
	          settings: {
	            centerMode: true,
	            centerPadding: "50px",
	            slidesToShow: 3,
	            slidesToScroll: 3
	          }
	        }, {
	          breakpoint: 1439,
	          settings: {
	            centerMode: true,
	            centerPadding: "100px",
	            slidesToShow: 3,
	            slidesToScroll: 3
	          }
	        }, {
	          breakpoint: 1719,
	          settings: {
	            centerMode: true,
	            centerPadding: "100px",
	            slidesToShow: 5,
	            slidesToScroll: 5
	          }
	        }]
	      });
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        if (_utils2.default.isNotNull(this.hideAnimationTimeout)) {
	          clearTimeout(this.hideAnimationTimeout);
	          this.hideAnimationTimeout = null;
	        }
	
	        this.$container.show();
	
	        var $slider = this.$element.find(".investments__slider");
	        $slider.slick("resize");
	        $slider.slick("setPosition");
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      var _this = this;
	
	      if (_utils2.default.isNotNull(this.$container) && this.$container.length) {
	        if (_utils2.default.isNotNull(this.hideAnimationTimeout)) {
	          clearTimeout(this.hideAnimationTimeout);
	          this.hideAnimationTimeout = null;
	        }
	
	        this.hideAnimationTimeout = setTimeout(function () {
	          _this.hideAnimationTimeout = null;
	          _this.$container.hide();
	        }, _constants2.default.BM_TRANSITION_SPEED);
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this2 = this;
	
	      this.$element.find(".category-tab-btn").off("click").on("click", function (e) {
	        var $this = $(e.currentTarget);
	        var category = $this.data("investment-category");
	
	        _this2.$element.find(".category-tab-btn").removeClass("category-active");
	        $this.addClass("category-active");
	
	        _this2.applyFilter(category);
	      });
	    }
	  }, {
	    key: "applyFilter",
	    value: function applyFilter(category) {
	      log.info("Filtering investments for category [%s]", category);
	
	      if (category === "all") {
	        this.$element.find(".investments__slider").slick("slickUnfilter");
	      } else {
	        this.$element.find(".investments__slider").slick("slickFilter", function (index) {
	          return !$(this).find(".investment-card").hasClass("ic-purchased");
	        });
	      }
	    }
	  }, {
	    key: "setUpInvestmentCardClickListener",
	    value: function setUpInvestmentCardClickListener() {
	      var _this3 = this;
	
	      this.$element.find(".investment-card").on("click", function (e) {
	        var $this = $(e.delegateTarget);
	        var investmentKey = $this.data("investment-key");
	        var $slickSlide = $this.closest(".slick-slide");
	
	        console.log("Clicked - %s", investmentKey);
	
	        var investment = _this3.getInvestmentForKey(investmentKey);
	
	        // Only allow to click on the active slides
	        if (_utils2.default.isNotNull(investment) && $slickSlide.hasClass("slick-active")) {
	          var isLocked = investment.redesignNeeded && !_this3.hasRedesign || investment.type === "biomaterials" && !_this3.hasUnlimitedResources;
	
	          if (!isLocked) {
	            if (_utils2.default.isFunction(_this3.onInvestmentClicked)) {
	              _this3.onInvestmentClicked.call(_this3, investment);
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: "getInvestmentForKey",
	    value: function getInvestmentForKey(key) {
	      if (_utils2.default.isNull(key)) return null;
	
	      for (var i = 0; i < this.investments.length; i++) {
	        if (this.investments[i].key === key) {
	          return this.investments[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "roundOverview",
	    get: function get() {
	      return this._roundOverview;
	    },
	    set: function set(roundOverview) {
	      this._roundOverview = roundOverview;
	      this.hasRedesign = this.currentRoundData.hasRedesign === true;
	      this.hasUnlimitedResources = this.currentRoundData.hasUnlimitedResources === true;
	
	      this.updateData();
	    }
	  }, {
	    key: "currentRoundData",
	    get: function get() {
	      return this.roundOverview.currentRoundData;
	    }
	  }], [{
	    key: "getCostForInvestment",
	    value: function getCostForInvestment(roundOverview, investment) {
	      var investmentCost = investment.cost === -1 ? roundOverview.currentRoundData.roundIndex : investment.cost;
	
	      // NOTE: hardcoded price change (also in investment-dialog)
	      if (_utils2.default.isNotNull(roundOverview.currentEvent) && roundOverview.currentEvent.type === "subsidy" && ["productredesign", "extraproduct"].includes(investment.type)) {
	        investmentCost += roundOverview.currentEvent.jsonData.value;
	      }
	
	      return investmentCost;
	    }
	  }, {
	    key: "canPurchaseInvestment",
	    value: function canPurchaseInvestment(team, roundOverview, investments, investment) {
	      var investmentCost = InvestmentSlider.getCostForInvestment(roundOverview, investment);
	      var canPurchase = roundOverview.currentRoundData.currentBudget >= investmentCost && _utils2.default.isNull(roundOverview.currentRoundData.investmentKey2);
	
	      if (investment.type !== "subsidy") {
	        var purchaseCount = InvestmentSlider.getInvestmentPurchaseCount(team, roundOverview, investment);
	
	        if (purchaseCount > 0) {
	          canPurchase = false;
	        }
	      } else {
	        canPurchase = canPurchase && InvestmentSlider.canPurchaseSubsidy(team, roundOverview, investments);
	      }
	
	      return canPurchase;
	    }
	  }, {
	    key: "getInvestmentPurchaseCount",
	    value: function getInvestmentPurchaseCount(team, roundOverview, investment) {
	      var purchaseCount = 0;
	
	      for (var roundIndex in team.roundData) {
	        // Only check rounds that have been started
	        if (team.roundData.hasOwnProperty(roundIndex) && _utils2.default.isNotNull(team.roundData[roundIndex].started) && team.roundData[roundIndex].roundIndex <= roundOverview.currentRoundData.roundIndex) {
	          var roundData = team.roundData[roundIndex];
	
	          if (roundData.investmentKey1 === investment.key || roundData.investmentKey2 === investment.key) {
	            purchaseCount++;
	          }
	        }
	      }
	
	      return purchaseCount;
	    }
	  }, {
	    key: "canPurchaseSubsidy",
	    value: function canPurchaseSubsidy(team, roundOverview, investments) {
	      var subsidyInvestment = InvestmentSlider.getInvestmentForType(investments, "subsidy");
	
	      if (_utils2.default.isNull(subsidyInvestment)) return false;
	
	      var subsidiesPurchased = InvestmentSlider.getInvestmentPurchaseCount(team, roundOverview, subsidyInvestment);
	      var subsidyApproved = roundOverview.currentRoundData.subsidyApproved;
	
	      if (subsidyApproved) {
	        return false;
	      } else {
	        // Can't purchase same investment twice in 1 round
	        if (roundOverview.currentRoundData.investmentKey1 === subsidyInvestment.key) return false;
	        return subsidiesPurchased < 2;
	      }
	    }
	  }, {
	    key: "getInvestmentForType",
	    value: function getInvestmentForType(investments, type) {
	      for (var i = 0; i < investments.length; i++) {
	        if (investments[i].type === type) {
	          return investments[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getIconCardForInvestment",
	    value: function getIconCardForInvestment(investmentType, locked) {
	      var requireKey = "./" + investmentType + ".svg";
	
	      if (!locked && iconCardsReq.keys().includes(requireKey)) {
	        return iconCardsReq(requireKey);
	      }
	
	      return iconCardsReq("./sloticon.svg");
	    }
	  }]);
	
	  return InvestmentSlider;
	}();
	
	exports.default = InvestmentSlider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 321:
47,

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./tutorial1.png": 452,
		"./tutorial2.png": 453,
		"./tutorial3.png": 454,
		"./tutorial4.png": 455,
		"./tutorial5.png": 456,
		"./tutorial6.png": 457,
		"./tutorial7.png": 458,
		"./tutorial8.png": 459
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 340;


/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./business-model.js": 481,
		"./game-view.js": 33,
		"./introduction.js": 482,
		"./quiz.js": 483,
		"./reconnect.js": 484,
		"./session-join.js": 485
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 461;


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-01 (14:21).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	
	__webpack_require__(47);
	__webpack_require__(727);
	
	var CloseRoundDialog = function () {
	  function CloseRoundDialog(options) {
	    _classCallCheck(this, CloseRoundDialog);
	
	    this.dialogId = _utils2.default.generateElementId("close-round-dialog-");
	
	    this._roundOverview = options.roundOverview;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	    this.onViewInvestments = options.onViewInvestments;
	    this.onCloseRound = options.onCloseRound;
	  }
	
	  _createClass(CloseRoundDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog close-round-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      if (_utils2.default.isNull(this.currentRoundData)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up close round dialog card - %o", this.currentRoundData);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $closeRoundContent = $("<div class='crd__content'></div>");
	
	        var $closeRoundTop = $("<div class='crd__top'></div>");
	
	        $closeRoundTop.append("<h6 class='crd__title'>" + _languageManager2.default.getValueForKey("serious_game.business_model.close_round.dialog.title") + "</h6>");
	
	        if (_utils2.default.isNull(this.currentRoundData.investmentKey1)) {
	          $closeRoundTop.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_model.close_round.dialog.text.2") + "</p>");
	        } else if (_utils2.default.isNull(this.currentRoundData.investmentKey2)) {
	          $closeRoundTop.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_model.close_round.dialog.text.1") + "</p>");
	        } else {
	          $closeRoundTop.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_model.close_round.dialog.text.0") + "</p>");
	        }
	
	        $closeRoundContent.append($closeRoundTop);
	
	        var $closeRoundActions = $("<div class='crd__actions'></div>");
	
	        if (_utils2.default.isNull(this.currentRoundData.investmentKey2)) {
	          $closeRoundActions.append("<button class='btn btn-outline-c-green btn-lg btn-block view-investments-btn' type='button'>" + _languageManager2.default.getValueForKey("serious_game.business_model.close_round.dialog.actions.investments") + "</button>");
	        }
	
	        $closeRoundActions.append("<button class='btn btn-outline-c-light-blue btn-lg btn-block close-round-btn' type='button'>" + _languageManager2.default.getValueForKey("serious_game.business_model.close_round.dialog.actions.close_round") + "</button>");
	
	        $closeRoundContent.append($closeRoundActions);
	
	        $dialogContent.append($closeRoundContent);
	
	        this.setUpCloseRoundEventListeners();
	      }
	    }
	  }, {
	    key: "setCloseRoundButtonLoading",
	    value: function setCloseRoundButtonLoading(flag) {
	      var $closeRoundBtn = this.$dialog.find(".close-round-btn");
	      $closeRoundBtn.removeClass("btn-loading").prop("disabled", flag);
	
	      if (flag) {
	        $closeRoundBtn.addClass("btn-loading");
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.setCloseRoundButtonLoading(false);
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpCloseRoundEventListeners",
	    value: function setUpCloseRoundEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	
	      this.$dialog.find(".view-investments-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onViewInvestments)) {
	          _this.onViewInvestments.call(_this.callbackContext, _this);
	        }
	      });
	
	      this.$dialog.find(".close-round-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCloseRound)) {
	          _this.onCloseRound.call(_this.callbackContext, _this);
	        }
	      });
	    }
	  }, {
	    key: "roundOverview",
	    get: function get() {
	      return this._roundOverview;
	    },
	    set: function set(roundOverview) {
	      this._roundOverview = roundOverview;
	      this.renderDialogContent();
	    }
	  }, {
	    key: "currentRoundData",
	    get: function get() {
	      return this.roundOverview.currentRoundData;
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return CloseRoundDialog;
	}();
	
	exports.default = CloseRoundDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-15 (14:42).
	 */
	var log = __webpack_require__(5)();
	
	
	__webpack_require__(729);
	
	var DataHistory = function () {
	  function DataHistory(options) {
	    _classCallCheck(this, DataHistory);
	
	    this.container = options.container ? $(options.container) : "body";
	    this.$triggerElement = $(options.triggerElement);
	    this.componentHtml = null;
	
	    this.boundary = options.boundary || "window";
	    this.trigger = options.trigger || "hover focus";
	
	    this.calculations = options.calculations;
	    this.total = options.total;
	
	    this.placement = options.placement || "top";
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	  }
	
	  _createClass(DataHistory, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      var _this = this;
	
	      if (this._initialized !== true) {
	        this.$triggerElement.popover({
	          boundary: this.boundary,
	          placement: this.placement,
	          trigger: this.trigger,
	          html: true,
	          offset: "90%",
	          template: "<div class='popover data-history-popover' role='tooltip'><div class='popover-arrow'></div><h3 class='popover-header'></h3><div class='popover-body'></div></div>",
	          content: function content() {
	            return _this.componentHtml;
	          }
	        });
	
	        this.$triggerElement.popover("hide");
	
	        this.setUpPopoverEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "setComponentHtml",
	    value: function setComponentHtml(roundOverview, type) {
	      if (_utils2.default.isNull(roundOverview)) return;
	      var data = DataHistory.getDataHistoryForRound(roundOverview, type);
	
	      this.calculations = data.calculations;
	      this.total = data.total;
	
	      try {
	        var $element = $("<div class='data-history'></div>");
	        if (_utils2.default.isNotNull(type)) {
	          $element.addClass("data-history__type-" + type);
	        }
	
	        var $calculations = $("<div class='data-history__calculations'></div>");
	
	        for (var i = 0; i < this.calculations.length; i++) {
	          var calculation = this.calculations[i];
	
	          var $row = $("<div class='data-history__row'></div>");
	          $row.append("<div class=\"data-history__label\">" + calculation.label + "</div>");
	          $row.append("<div class=\"data-history__value\">" + calculation.value + "</div>");
	
	          $calculations.append($row);
	        }
	
	        $element.append($calculations);
	
	        if (_utils2.default.isNotNull(this.total)) {
	          var $dataHistoryTotal = $("<div class='data-history__total'></div>");
	
	          var _$row = $("<div class='data-history__row'></div>");
	          _$row.append("<div class=\"data-history__label\">" + this.total.label + "</div>");
	          _$row.append("<div class=\"data-history__value\">" + this.total.value + "</div>");
	
	          $dataHistoryTotal.append(_$row);
	
	          $element.append($dataHistoryTotal);
	        }
	
	        this.componentHtml = $element.prop("outerHTML");
	      } catch (e) {
	        log.error("Failed to render data history component - %o", e);
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$triggerElement) && this.$triggerElement.length && _utils2.default.isNotNull(this.componentHtml)) {
	        if (_utils2.default.isNotNull(this.hideAnimationTimeout)) {
	          clearTimeout(this.hideAnimationTimeout);
	          this.hideAnimationTimeout = null;
	        }
	
	        this.$triggerElement.focus();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$triggerElement) && this.$triggerElement.length) {
	        if (_utils2.default.isNotNull(this.hideAnimationTimeout)) {
	          clearTimeout(this.hideAnimationTimeout);
	          this.hideAnimationTimeout = null;
	        }
	
	        this.$triggerElement.popover("dispose");
	      }
	    }
	  }, {
	    key: "setUpPopoverEventListeners",
	    value: function setUpPopoverEventListeners() {
	      var _this2 = this;
	
	      this.$triggerElement.on("hide.bs.popover", function (e) {
	        if (_utils2.default.isFunction(_this2.onCancel)) {
	          _this2.onCancel.apply(_this2.callbackContext, _this2);
	        }
	      });
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {}
	  }], [{
	    key: "getDataHistoryForRound",
	    value: function getDataHistoryForRound(roundOverview, type) {
	      if (_utils2.default.isNull(roundOverview) || !_utils2.default.isArray(roundOverview.dataHistory) || roundOverview.dataHistory.length === 0) return null;
	
	      var total = {};
	      var calculations = [];
	
	      if (type === "points") {
	        for (var i = 0; i < roundOverview.dataHistory.length; i++) {
	          var currentRoundDataHistory = roundOverview.dataHistory[i];
	
	          // Skip quiz round
	          if (i === 0) continue;
	
	          var sign = currentRoundDataHistory.pointsGained >= 0 ? "+" : "";
	
	          calculations.push({
	            label: _utils2.default.format(_languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.round"), currentRoundDataHistory.roundIndex),
	            value: sign + currentRoundDataHistory.pointsGained
	          });
	
	          if (roundOverview.dataHistory[i].roundIndex === roundOverview.currentRoundData.roundIndex) {
	            total = {
	              label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.total_points"),
	              value: currentRoundDataHistory.totalPoints
	            };
	
	            break;
	          }
	        }
	      } else {
	        var _currentRoundDataHistory = void 0;
	        var _sign = void 0;
	
	        for (var _i = 0; _i < roundOverview.dataHistory.length; _i++) {
	          if (roundOverview.dataHistory[_i].roundIndex === roundOverview.currentRoundData.roundIndex) {
	            _currentRoundDataHistory = roundOverview.dataHistory[_i];
	            break;
	          }
	        }
	
	        if (_utils2.default.isNull(_currentRoundDataHistory)) return null;
	
	        // Start budget
	        calculations.push({
	          label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.start_budget"),
	          value: _currentRoundDataHistory.startBudget
	        });
	
	        // Start income
	        _sign = _currentRoundDataHistory.startIncome >= 0 ? "+" : "";
	        calculations.push({
	          label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.start_income"),
	          value: _sign + _currentRoundDataHistory.startIncome
	        });
	
	        // Event
	        if (_utils2.default.isNotNull(_currentRoundDataHistory.eventBudgetEffect)) {
	          _sign = _currentRoundDataHistory.eventBudgetEffect >= 0 ? "+" : "";
	
	          calculations.push({
	            label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.event"),
	            value: _sign + _currentRoundDataHistory.eventBudgetEffect
	          });
	        }
	
	        // Subsidy
	        if (_utils2.default.isNotNull(_currentRoundDataHistory.subsidyBudget)) {
	          _sign = _currentRoundDataHistory.subsidyBudget >= 0 ? "+" : "";
	
	          calculations.push({
	            label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.subsidy"),
	            value: _sign + _currentRoundDataHistory.subsidyBudget
	          });
	        }
	
	        // Loaned
	        if (_utils2.default.isNotNull(_currentRoundDataHistory.loaned) && _currentRoundDataHistory.loaned > 0) {
	          _sign = _currentRoundDataHistory.loaned >= 0 ? "+" : "";
	
	          calculations.push({
	            label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.loan"),
	            value: _sign + _currentRoundDataHistory.loaned
	          });
	        }
	
	        // Investments
	        if (_utils2.default.isNotNull(_currentRoundDataHistory.investmentBudgetEffect)) {
	          _sign = _currentRoundDataHistory.investmentBudgetEffect >= 0 ? "+" : "";
	
	          calculations.push({
	            label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.investments"),
	            value: _sign + _currentRoundDataHistory.investmentBudgetEffect
	          });
	        }
	
	        total = {
	          label: _languageManager2.default.getValueForKey("serious_game.business_model.data_history.labels.total_budget"),
	          value: _currentRoundDataHistory.totalBudget
	        };
	      }
	
	      return {
	        calculations: calculations,
	        total: total
	      };
	    }
	  }]);
	
	  return DataHistory;
	}();
	
	exports.default = DataHistory;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _eventPanel = __webpack_require__(346);
	
	var _eventPanel2 = _interopRequireDefault(_eventPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-01 (14:21).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	
	
	__webpack_require__(47);
	__webpack_require__(730);
	
	var EventDialog = function () {
	  function EventDialog(options) {
	    _classCallCheck(this, EventDialog);
	
	    this.dialogId = _utils2.default.generateElementId("event-dialog-");
	
	    this._event = options.event;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	  }
	
	  _createClass(EventDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.eventPanel = new _eventPanel2.default();
	
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog event-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      if (_utils2.default.isNull(this.event)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up event dialog for event - %o", this.event);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        this.eventPanel.appendTo = $dialogContent;
	        this.eventPanel.event = this.event;
	
	        this.setUpCloseRoundEventListeners();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpCloseRoundEventListeners",
	    value: function setUpCloseRoundEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	    }
	  }, {
	    key: "event",
	    get: function get() {
	      return this._event;
	    },
	    set: function set(event) {
	      this._event = event;
	      this.renderDialogContent();
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return EventDialog;
	}();
	
	exports.default = EventDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	__webpack_require__(339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-14 (11:41).
	 */
	__webpack_require__(323);
	__webpack_require__(322);
	
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	var ArrowShortSvg = __webpack_require__(338);
	
	__webpack_require__(47);
	__webpack_require__(393);
	__webpack_require__(732);
	
	var ExampleCaseDialog = function () {
	  function ExampleCaseDialog(options) {
	    _classCallCheck(this, ExampleCaseDialog);
	
	    this.dialogId = _utils2.default.generateElementId("example-case-dialog-");
	
	    this.investment = options.investment;
	    this.investments = options.investments;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	  }
	
	  _createClass(ExampleCaseDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog slider-dialog example-case-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      if (_utils2.default.isNull(this.investment)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up example cases dialog card for investment - %o", this.investment);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $exampleCase = $("<div class='example-case'></div>");
	
	        // Dialog top
	        var $exampleCaseTop = $("<div class='example-case__top'></div>");
	
	        var investmentTitle = _languageManager2.default.getValueForKey("serious_game.business_model.investments.back.titles." + this.investment.type);
	        $exampleCaseTop.append("<h5 class='example-case__dialog-title'>" + investmentTitle + "</h5>");
	
	        var $sliderPrevBtn = $("<button class=\"btn btn-slider btn-slider__prev slider-dialog__prev-btn\" type=\"button\">" + ArrowShortSvg + "</button>");
	        var $sliderNextBtn = $("<button class=\"btn btn-slider btn-slider__next slider-dialog__next-btn\" type=\"button\">" + ArrowShortSvg + "</button>");
	        var $imageSlider = $("<div class='example-case__image-slider'></div>");
	
	        $exampleCaseTop.append($sliderPrevBtn);
	        $exampleCaseTop.append($imageSlider);
	        $exampleCaseTop.append($sliderNextBtn);
	
	        // Dialog bottom
	        var $exampleCaseBottom = $("<div class='example-case__bottom'></div>");
	
	        var $contentSlider = $("<div class='example-case__content-slider'></div>");
	        $exampleCaseBottom.append($contentSlider);
	
	        for (var i = 0; i < this.investment.examples.length; i++) {
	          var example = this.investment.examples[i];
	
	          var $exampleImage = $("<div class='example-case__image'></div>");
	          var credits = _languageManager2.default.getValueForKey("serious_game.business_model.investments.examples.credit.prefix") + example.credits;
	          $exampleImage.append("<figure><img src=\"" + example.image + "\" alt=\"" + example.title + "\"/><figcaption>" + credits + "</figcaption></figure>");
	          $imageSlider.append($exampleImage);
	
	          var $exampleContent = $("<div class='example-case__content'></div>");
	          $exampleContent.append("<h6 class=\"example-case__content-title\">" + example.title + "</h6>");
	          $exampleContent.append("<p class=\"example-case__content-text\">" + example.description + "</p>");
	          $contentSlider.append($exampleContent);
	        }
	
	        $exampleCase.append($exampleCaseTop).append($exampleCaseBottom);
	        $dialogContent.append($exampleCase);
	
	        this.setUpSlick();
	
	        this.setUpEventListeners();
	      }
	    }
	  }, {
	    key: "setUpSlick",
	    value: function setUpSlick() {
	      var $imageSlider = this.$dialog.find(".example-case__image-slider");
	      var $contentSlider = this.$dialog.find(".example-case__content-slider");
	
	      var slickOptionsDefault = {
	        focusOnSelect: false,
	
	        mobileFirst: true,
	
	        draggable: false,
	        swipe: true,
	
	        infinite: false,
	
	        // dots: true,
	        arrows: true,
	        prevArrow: this.$dialog.find(".slider-dialog__prev-btn"),
	        nextArrow: this.$dialog.find(".slider-dialog__next-btn"),
	
	        slidesToShow: 1,
	        slidesToScroll: 1,
	
	        // Without this, adding slides after the initialize is fcked up for some reason:
	        // https://github.com/kenwheeler/slick/commit/be0d17cc858fb30e6a4d6b28cc29860c7170040d#comments
	        rows: 0
	      };
	
	      var imageSliderOptions = _extends({}, slickOptionsDefault, {
	        asNavFor: $contentSlider
	      });
	
	      var contentSliderOptions = _extends({}, slickOptionsDefault, {
	        arrows: false,
	        dots: true,
	        appendDots: this.$dialog.find(".modal-content"),
	        asNavFor: $imageSlider
	      });
	
	      $imageSlider.slick(imageSliderOptions);
	      $contentSlider.slick(contentSliderOptions);
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.renderDialogContent();
	      this.$dialog.modal("show");
	
	      var $imageSlider = this.$dialog.find(".example-case__image-slider");
	      var $contentSlider = this.$dialog.find(".example-case__content-slider");
	      $imageSlider.slick("resize");
	      $imageSlider.slick("setPosition");
	      $contentSlider.slick("resize");
	      $contentSlider.slick("setPosition");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return ExampleCaseDialog;
	}();
	
	exports.default = ExampleCaseDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-17 (10:41).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	
	__webpack_require__(47);
	__webpack_require__(733);
	
	var FaqDialog = function () {
	  function FaqDialog(options) {
	    _classCallCheck(this, FaqDialog);
	
	    this.dialogId = _utils2.default.generateElementId("faq-dialog-");
	
	    this.faqItems = options.faqItems;
	    this.investments = options.investments;
	    this._faqType = options.faqType;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	    this.onViewInvestment = options.onViewInvestment;
	  }
	
	  _createClass(FaqDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog faq-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var _this = this;
	
	      if (_utils2.default.isNull(this.faqType)) return;
	
	      var faqItem = this.getFaqItemForType();
	
	      if (_utils2.default.isNull(faqItem)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up faq dialog - %o", faqItem);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $faqContent = $("<div class='faq-dialog__content'></div>");
	
	        var investment = null;
	
	        if (_utils2.default.isNotNull(faqItem.investmentKey)) {
	          investment = this.getInvestmentForFaqItem(faqItem);
	
	          /*if(utils.isNotNull(investment))
	          {
	            let $faqTop = $("<div class='faq-dialog__top'></div>");
	             // TODO icon
	            $faqTop.append(`<h6 class='faq-dialog__title'>${LanguageManager.getValueForKey("serious_game.business_model.close_round.dialog.title")}</h6>`);
	             $faqContent.append($faqTop);
	          }*/
	        }
	
	        var $faqBottom = $("<div class='faq-dialog__bottom'></div>");
	
	        $faqBottom.append("<div class=\"faq-dialog__text\">" + faqItem.description + "</div>");
	
	        if (_utils2.default.isNotNull(faqItem.investmentKey) && _utils2.default.isNotNull(investment)) {
	          var $faqActions = $("<div class='faq__actions'></div>");
	
	          var $viewInvestmentButton = $("<button class='btn btn-outline-c-light-blue btn-lg view-investment-btn' type='button'>" + _languageManager2.default.getValueForKey("serious_game.business_model.faq.dialog.actions.investment") + "</button>");
	
	          $viewInvestmentButton.on("click", function (e) {
	            if (_utils2.default.isFunction(_this.onViewInvestment)) {
	              _this.onViewInvestment.call(_this.callbackContext, _this, investment);
	            }
	          });
	
	          $faqActions.append($viewInvestmentButton);
	
	          $faqBottom.append($faqActions);
	        }
	
	        $faqContent.append($faqBottom);
	
	        $dialogContent.append($faqContent);
	
	        this.setUpEventListeners();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this2 = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this2.onCancel)) {
	          _this2.onCancel.call(_this2.callbackContext, _this2);
	        }
	      });
	    }
	  }, {
	    key: "getInvestmentForFaqItem",
	    value: function getInvestmentForFaqItem(faqItem) {
	      if (_utils2.default.isNull(faqItem.investmentKey)) return null;
	      if (_utils2.default.isNull(this.investments)) return null;
	
	      for (var i = 0; i < this.investments.length; i++) {
	        if (this.investments[i].key === faqItem.investmentKey) {
	          return this.investments[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getFaqItemForType",
	    value: function getFaqItemForType() {
	      for (var i = 0; i < this.faqItems.length; i++) {
	        if (this.faqType === this.faqItems[i].type) {
	          return this.faqItems[i];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "faqType",
	    get: function get() {
	      return this._faqType;
	    },
	    set: function set(faqType) {
	      this._faqType = faqType;
	      this.renderDialogContent();
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return FaqDialog;
	}();
	
	exports.default = FaqDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-17 (10:41).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	var GameBonusIcon = __webpack_require__(853);
	
	__webpack_require__(47);
	__webpack_require__(734);
	
	var GameBonusDialog = function () {
	  function GameBonusDialog(options) {
	    _classCallCheck(this, GameBonusDialog);
	
	    this.dialogId = _utils2.default.generateElementId("game-bonus-dialog-");
	
	    this.bonus = options.bonus;
	    this.circular = options.circular === true;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	  }
	
	  _createClass(GameBonusDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog game-bonus-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up game bonus dialog - bonus: %d", this.bonus);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $gameBonusContent = $("<div class='gbd__content'></div>");
	
	        var $gameBonusTop = $("<div class='gbd__top'></div>");
	
	        $gameBonusTop.append("<div class=\"gbd__icon\">" + GameBonusIcon + "</div>");
	        $gameBonusTop.append("<h4 class=\"gbd__title\">" + _languageManager2.default.getValueForKey("serious_game.business_mode.game_bonus.dialog.title") + "</h4>");
	
	        var $gameBonusBottom = $("<div class='gbd__bottom'></div>");
	
	        if (this.circular) {
	          $gameBonusBottom.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_mode.game_bonus.dialog.circular.text") + "</p>");
	        } else {
	          $gameBonusBottom.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_mode.game_bonus.dialog.text") + "</p>");
	        }
	
	        var $gameBonusDataGroup = $("<div class='gbd__data-group'></div>");
	        $gameBonusDataGroup.append("<div class='game-bonus__data-value game-bonus-data game-bonus-data__points' data-gbd-bonus=\"" + this.bonus + "\">" + this.bonus + "</div>");
	
	        $gameBonusBottom.append($gameBonusDataGroup);
	
	        $gameBonusContent.append($gameBonusTop);
	        $gameBonusContent.append($gameBonusBottom);
	
	        $dialogContent.append($gameBonusContent);
	
	        this.setUpCloseRoundEventListeners();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpCloseRoundEventListeners",
	    value: function setUpCloseRoundEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	    }
	  }, {
	    key: "bonus",
	    get: function get() {
	      return this._bonus;
	    },
	    set: function set(bonus) {
	      this._bonus = bonus;
	
	      if (_utils2.default.isNotNull(this.$dialog) && this.$dialog.length) {
	        this.$dialog.find("[data-gbd-bonus]").text(this.bonus);
	      }
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return GameBonusDialog;
	}();
	
	exports.default = GameBonusDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _investmentSlider = __webpack_require__(290);
	
	var _investmentSlider2 = _interopRequireDefault(_investmentSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-26 (15:56).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	
	__webpack_require__(321);
	__webpack_require__(47);
	__webpack_require__(736);
	
	var InvestmentDialog = function () {
	  function InvestmentDialog(options) {
	    _classCallCheck(this, InvestmentDialog);
	
	    this.dialogId = _utils2.default.generateElementId("investment-dialog-");
	    this.investment = options.investment;
	
	    this.team = options.team;
	    this.roundOverview = options.roundOverview;
	    this.investments = options.investments;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	    this.onViewExampleCases = options.onViewExampleCases;
	    this.onPreview = options.onPreview;
	    this.onPurchase = options.onPurchase;
	  }
	
	  _createClass(InvestmentDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog investment-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      if (_utils2.default.isNull(this.investment)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up investment dialog card for investment - %o", this.investment);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $investmentCardWrapper = $("<div class='ic__wrapper'></div>");
	
	        var $investmentCardBack = $("<div class='investment-card investment-card__back'></div>");
	        $investmentCardBack.attr("data-investment-key", this.investment.key);
	        $investmentCardBack.attr("data-investment-type", this.investment.type);
	        $investmentCardBack.attr("data-investment-category", this.investment.category);
	        $investmentCardBack.addClass("ic__type-" + this.investment.type);
	
	        var $cardTop = $("<div class='investment-card__top'></div>");
	
	        var $investmentCost = $("<div class='ic__cost'></div>");
	        // NOTE: cost "-1" means that the cost == current round
	        var investmentCost = _investmentSlider2.default.getCostForInvestment(this.roundOverview, this.investment);
	        var $investmentCostValue = $("<div class='ic-data ic-data__budget'></div>");
	
	        if (this.investment.cost === -1) {
	          $investmentCost.addClass("ic__dynamic-cost");
	          $investmentCostValue.append("<span class='ic__dynamic-cost-label'>R</span>").append("<span class=\"ic__dynamic-cost-value\">" + investmentCost + "</span>");
	        } else {
	          $investmentCostValue.text(investmentCost);
	        }
	
	        $investmentCost.append($investmentCostValue);
	
	        if (this.investment.redesignNeeded) {
	          $investmentCost.append("<div class='ic-data ic-data__research'></div>");
	        }
	
	        $investmentCost.append("<div class='ic__cost-label'>" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.cost.label") + "</div>");
	        $cardTop.append($investmentCost);
	
	        var $investmentIcon = $("<div class='ic__icon'></div>").html(_investmentSlider2.default.getIconCardForInvestment(this.investment.type, false));
	        $cardTop.append($investmentIcon);
	
	        // $cardTop.append(`<h5 class='ic__title'>${utils.escapeHtml(investment.title)}</h5>`);
	        var investmentTitle = _languageManager2.default.getValueForKey("serious_game.business_model.investments.back.titles." + this.investment.type);
	        $cardTop.append("<h5 class='ic__title'>" + investmentTitle + "</h5>");
	        $cardTop.append("<p class='ic__description'>" + _utils2.default.escapeHtml(this.investment.description) + "</p>");
	
	        var $cardBottom = $("<div class='investment-card__bottom'></div>");
	        var $investmentActions = $("<div class='ic__actions'></div>");
	
	        var $showExamplesBtn = $("<button class='btn btn-outline-c-green btn-lg example-cases-btn' type='button'>" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.actions.examples_btn") + "</button>");
	        $showExamplesBtn.prop("disabled", this.investment.examples.length === 0);
	        $investmentActions.append($showExamplesBtn);
	
	        $investmentActions.append("<button class='btn btn-outline-c-light-blue btn-lg preview-investment-btn' type='button'>" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.actions.preview_btn") + "</button>");
	
	        var $purchaseBtn = $("<button class='btn btn-outline-c-yellow btn-lg purchase-investment-btn' type='button'>" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.actions.purchase_btn") + "</button>");
	
	        // Has enough budget AND hasn't purchased 2 investments
	        var canPurchase = _investmentSlider2.default.canPurchaseInvestment(this.team, this.roundOverview, this.investments, this.investment);
	        $purchaseBtn.prop("disabled", !canPurchase);
	
	        $investmentActions.append($purchaseBtn);
	
	        $cardBottom.append($investmentActions);
	
	        $investmentCardBack.append($cardTop).append($cardBottom);
	        $investmentCardWrapper.append($investmentCardBack);
	        $dialogContent.append($investmentCardWrapper);
	
	        this.setUpInvestmentEventListeners();
	      }
	    }
	  }, {
	    key: "setPurchaseButtonLoading",
	    value: function setPurchaseButtonLoading(flag) {
	      var $purchaseBtn = this.$dialog.find(".purchase-investment-btn");
	      $purchaseBtn.removeClass("btn-loading").prop("disabled", flag);
	
	      if (flag) {
	        $purchaseBtn.addClass("btn-loading");
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.cancelShow = false;
	      this.setPurchaseButtonLoading(false);
	      this.renderDialogContent();
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.cancelShow = true;
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {
	      var _this = this;
	
	      this.$dialog.on("show.bs.modal", function (e) {
	        if (_this.cancelShow) {
	          _this.cancelShow = false;
	          e.preventDefault();
	        }
	      });
	
	      this.$dialog.on("shown.bs.modal", function (e) {
	        if (_this.cancelShow) {
	          _this.cancelShow = false;
	          _this.hide();
	        }
	      });
	
	      this.$dialog.on("hide.bs.modal", function (e) {
	        _this.cancelShow = false;
	      });
	
	      this.$dialog.on("hidden.bs.modal", function (e) {
	        _this.cancelShow = false;
	      });
	    }
	  }, {
	    key: "setUpInvestmentEventListeners",
	    value: function setUpInvestmentEventListeners() {
	      var _this2 = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this2.onCancel)) {
	          _this2.onCancel.call(_this2.callbackContext, _this2);
	        }
	      });
	
	      this.$dialog.find(".example-cases-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this2.onViewExampleCases)) {
	          _this2.onViewExampleCases.call(_this2.callbackContext, _this2);
	        }
	      });
	
	      this.$dialog.find(".preview-investment-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this2.onPreview)) {
	          _this2.onPreview.call(_this2.callbackContext, _this2);
	        }
	      });
	
	      this.$dialog.find(".purchase-investment-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this2.onPurchase)) {
	          _this2.onPurchase.call(_this2.callbackContext, _this2);
	        }
	      });
	    }
	  }, {
	    key: "currentRoundData",
	    get: function get() {
	      return this.roundOverview.currentRoundData;
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return InvestmentDialog;
	}();
	
	exports.default = InvestmentDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _investmentSlider = __webpack_require__(290);
	
	var _investmentSlider2 = _interopRequireDefault(_investmentSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-07 (16:10).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	
	__webpack_require__(321);
	__webpack_require__(47);
	__webpack_require__(737);
	
	var InvestmentExtraDialog = function () {
	  function InvestmentExtraDialog(options) {
	    _classCallCheck(this, InvestmentExtraDialog);
	
	    this.dialogId = _utils2.default.generateElementId("investment-extra-dialog-");
	
	    this.type = options.type;
	    this.investment = options.investment;
	    this.extraData = options.extraData;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	
	    this.onExtraProductSelected = options.onExtraProductSelected;
	  }
	
	  _createClass(InvestmentExtraDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog investment-extra-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      if (_utils2.default.isNull(this.investment)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up investment extra dialog card for type - %s", this.investment.type);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $investmentExtraContent = $("<div class='ied__content'></div>");
	        $investmentExtraContent.addClass("ied__type-" + this.investment.type);
	
	        var $contentTop = $("<div class='ied__top'></div>");
	
	        var icon = _investmentSlider2.default.getIconCardForInvestment(this.investment.type, false);
	        var $icon = $("<div class='ied__icon'></div>");
	        if (_utils2.default.isNotNull(icon)) {
	          $icon.append(icon);
	        }
	
	        $contentTop.append($icon);
	        $contentTop.append("<h4 class=\"ied__title\">" + InvestmentExtraDialog.getTitleForType(this.investment.type) + "</h4>");
	
	        var $contentBottom = $("<div class='ied__bottom'></div>");
	
	        var $eventDataHtml = this.getHtmlForInvestmentExtra();
	
	        if (_utils2.default.isNotNull($eventDataHtml)) {
	          $contentBottom.append($eventDataHtml);
	        }
	
	        $investmentExtraContent.append($contentTop);
	        $investmentExtraContent.append($contentBottom);
	
	        $dialogContent.append($investmentExtraContent);
	
	        this.setUpEventListeners();
	      }
	    }
	  }, {
	    key: "getHtmlForInvestmentExtra",
	    value: function getHtmlForInvestmentExtra() {
	      if (this.investment.type === "subsidy") {
	        return InvestmentExtraDialog.getSubsidyHtml(this.investment, this.extraData.subsidyApproved);
	      } else if (this.investment.type === "extraproduct") {
	        return InvestmentExtraDialog.getExtraProductHtml(this.investment, this.extraData.extraProductIcons);
	      }
	
	      return null;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.renderDialogContent();
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "disableProductButtons",
	    value: function disableProductButtons(flag) {
	      this.$dialog.find(".ied__product").prop("disabled", flag);
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	
	      this.$dialog.find(".ied__product").on("click", function (e) {
	        var $this = $(e.delegateTarget);
	        var productType = $this.data("extra-product");
	
	        if (_utils2.default.isFunction(_this.onExtraProductSelected)) {
	          _this.onExtraProductSelected.call(_this.callbackContext, productType);
	        }
	      });
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }], [{
	    key: "getTitleForType",
	    value: function getTitleForType(type) {
	      return _languageManager2.default.getValueForKey("serious_game.business_model.investments.extra.titles." + type);
	    }
	  }, {
	    key: "getExtraProductHtml",
	    value: function getExtraProductHtml(extraProductInvestment, icons) {
	      var $investmentExtraHtml = $("<div class='ied__data-wrapper'></div>");
	
	      $investmentExtraHtml.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.extra.content.extraproduct1") + "</p>");
	
	      var $extraProducts = $("<div class='ied__products-wrapper'></div>");
	
	      for (var i = 0; i < icons.length; i++) {
	        var icon = icons[i];
	        var $icon = $("<div class='ied__product'><div class=\"ied__product-icon\"><img src=\"" + icon.value + "\" alt=\"" + icon.type + "\"/></div></div>");
	        $icon.data("extra-product", icon.type);
	
	        $extraProducts.append($icon);
	      }
	
	      $investmentExtraHtml.append($extraProducts);
	
	      return $investmentExtraHtml;
	    }
	  }, {
	    key: "getSubsidyHtml",
	    value: function getSubsidyHtml(subsidyInvestment, approved) {
	      var $investmentExtraHtml = $("<div class='ied__data-wrapper'></div>");
	
	      $investmentExtraHtml.append("<p class=\"text-center\">" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.extra.content.subsidy.shared") + "</p>");
	
	      if (approved) {
	        $investmentExtraHtml.append("<p class=\"mt-5 text-uppercase font-weight-medium\">" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.extra.content.subsidy.approved") + "</p>");
	
	        var $subsidyDataGroup = $("<div class='ied__data-group'></div>");
	        $subsidyDataGroup.append("<div class='ied__data-value ic-data ic-data__budget'>" + subsidyInvestment.income + "</div>");
	        $subsidyDataGroup.append("<div class='ied__data-value ic-data ic-data__points'>" + subsidyInvestment.points + "</div>");
	
	        $investmentExtraHtml.append($subsidyDataGroup);
	      } else {
	        $investmentExtraHtml.append("<p class=\"mt-5 text-uppercase font-weight-medium\">" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.extra.content.subsidy.denied") + "</p>");
	      }
	
	      return $investmentExtraHtml;
	    }
	  }]);
	
	  return InvestmentExtraDialog;
	}();
	
	exports.default = InvestmentExtraDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-01 (14:21).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	var LoanIcon = __webpack_require__(852);
	
	__webpack_require__(47);
	__webpack_require__(739);
	
	var LoanDialog = function () {
	  function LoanDialog(options) {
	    _classCallCheck(this, LoanDialog);
	
	    this.dialogId = _utils2.default.generateElementId("loan-dialog-");
	
	    this._type = options.type || "auto-loan";
	
	    this.roundOverview = options.roundOverview;
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	    this.onRequestLoan = options.onRequestLoan;
	  }
	
	  _createClass(LoanDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog loan-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      if (_utils2.default.isNull(this.roundOverview)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up loan dialog (type: %s) - %o", this.type, this.roundOverview);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $loanDialogContent = $("<div class='loan-dialog__content'></div>");
	        var $loanDialogTop = $("<div class='loan-dialog__top'></div>");
	        $loanDialogContent.append($loanDialogTop);
	
	        var $loanDialogBottom = $("<div class='loan-dialog__bottom'></div>");
	        $loanDialogContent.append($loanDialogBottom);
	
	        $loanDialogTop.append("<div class='loan-dialog__icon'>" + LoanIcon + "</div>");
	
	        if (this.type === "request-loan") {
	          $loanDialogTop.append("<h6 class='loan-dialog__title'>" + _languageManager2.default.getValueForKey("serious_game.business_model.loan.dialog.request.title") + "</h6>");
	
	          $loanDialogBottom.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_model.loan.dialog.request.text") + "</p>");
	
	          var $loanDialogActions = $("<div class='loan-dialog__actions'></div>");
	          $loanDialogActions.append("<button class='btn btn-outline-c-light-blue btn-lg btn-block request-loan-btn' type='button'>" + _languageManager2.default.getValueForKey("serious_game.business_model.loan.dialog.actions.request_loan") + "</button>");
	
	          $loanDialogBottom.append($loanDialogActions);
	        } else if (this.type === "auto-loan") {
	          $loanDialogTop.append("<h6 class='loan-dialog__title'>" + _languageManager2.default.getValueForKey("serious_game.business_model.loan.dialog.auto.title") + "</h6>");
	          $loanDialogBottom.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_model.loan.dialog.auto.text") + "</p>");
	        } else if (this.type === "optional-loan") {
	          $loanDialogTop.append("<h6 class='loan-dialog__title'>" + _languageManager2.default.getValueForKey("serious_game.business_model.loan.dialog.optional.title") + "</h6>");
	          $loanDialogBottom.append("<p>" + _languageManager2.default.getValueForKey("serious_game.business_model.loan.dialog.optional.text") + "</p>");
	        }
	
	        $dialogContent.append($loanDialogContent);
	
	        this.setUpEventListeners();
	      }
	    }
	  }, {
	    key: "setRequestLoanButtonLoading",
	    value: function setRequestLoanButtonLoading(flag) {
	      var $requestLoanBtn = this.$dialog.find(".request-loan-btn");
	      $requestLoanBtn.removeClass("btn-loading").prop("disabled", flag);
	
	      if (flag) {
	        $requestLoanBtn.addClass("btn-loading");
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.setRequestLoanButtonLoading(false);
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	
	      this.$dialog.find(".request-loan-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onRequestLoan)) {
	          _this.onRequestLoan.call(_this.callbackContext, _this);
	        }
	      });
	    }
	  }, {
	    key: "type",
	    get: function get() {
	      return this._type;
	    },
	    set: function set(type) {
	      this._type = type;
	      this.renderDialogContent();
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return LoanDialog;
	}();
	
	exports.default = LoanDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _gameView = __webpack_require__(33);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _businessModel = __webpack_require__(795);
	
	var _businessModel2 = _interopRequireDefault(_businessModel);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _gameProgressController = __webpack_require__(349);
	
	var _gameProgressController2 = _interopRequireDefault(_gameProgressController);
	
	var _businessModel3 = __webpack_require__(226);
	
	var _businessModel4 = _interopRequireDefault(_businessModel3);
	
	var _default = __webpack_require__(212);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _investmentSlider = __webpack_require__(290);
	
	var _investmentSlider2 = _interopRequireDefault(_investmentSlider);
	
	var _investmentDialog = __webpack_require__(478);
	
	var _investmentDialog2 = _interopRequireDefault(_investmentDialog);
	
	var _investmentExtraDialog = __webpack_require__(479);
	
	var _investmentExtraDialog2 = _interopRequireDefault(_investmentExtraDialog);
	
	var _closeRoundDialog = __webpack_require__(472);
	
	var _closeRoundDialog2 = _interopRequireDefault(_closeRoundDialog);
	
	var _tutorialDialog = __webpack_require__(347);
	
	var _tutorialDialog2 = _interopRequireDefault(_tutorialDialog);
	
	var _eventDialog = __webpack_require__(474);
	
	var _eventDialog2 = _interopRequireDefault(_eventDialog);
	
	var _exampleCaseDialog = __webpack_require__(475);
	
	var _exampleCaseDialog2 = _interopRequireDefault(_exampleCaseDialog);
	
	var _faqDialog = __webpack_require__(476);
	
	var _faqDialog2 = _interopRequireDefault(_faqDialog);
	
	var _gameBonusDialog = __webpack_require__(477);
	
	var _gameBonusDialog2 = _interopRequireDefault(_gameBonusDialog);
	
	var _loanDialog = __webpack_require__(480);
	
	var _loanDialog2 = _interopRequireDefault(_loanDialog);
	
	var _scoreScreen = __webpack_require__(291);
	
	var _scoreScreen2 = _interopRequireDefault(_scoreScreen);
	
	var _dataHistory = __webpack_require__(473);
	
	var _dataHistory2 = _interopRequireDefault(_dataHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Created by jv on 2019-09-10 (14:34).
	 */
	var log = __webpack_require__(5)();
	// import CONSTANTS from "Sources/config/constants";
	// %NOTE: CMS.faq also uses this config, please change there too :)
	
	
	__webpack_require__(749);
	
	var BusinessModelView = function (_GameView) {
	  _inherits(BusinessModelView, _GameView);
	
	  function BusinessModelView(options) {
	    _classCallCheck(this, BusinessModelView);
	
	    options.html = $(_businessModel2.default);
	
	    var _this = _possibleConstructorReturn(this, (BusinessModelView.__proto__ || Object.getPrototypeOf(BusinessModelView)).call(this, options));
	
	    _this.path = "business-model";
	
	    _this.businessModel = null;
	
	    _this.gameSession = options.gameSession;
	    _this.team = options.team;
	    _this.caseWrapper = options.caseWrapper;
	    _this.roundOverview = options.roundOverview;
	
	    _this.scoreScreenMode = null;
	
	    _this.onRenderCompleted = options.onRenderComplete;
	
	    _this.onInvestmentAdded = options.onInvestmentAdded;
	    _this.onTeamClosedRound = options.onTeamClosedRound;
	    _this.onTeamRequestedLoan = options.onTeamRequestedLoan;
	    _this.onTeamOverviewChanged = options.onTeamOverviewChanged;
	
	    _this.executeOnRender = [];
	    _this.executeOnEventClose = [];
	    _this.executeOnInvestmentClose = [];
	    _this.executeOnInvestmentExtraClose = [];
	    _this.executeOnExampleCasesClose = [];
	    _this.executeOnTutorialClose = [];
	    _this.executeOnLoanDialogClose = [];
	
	    _this.showBusinessModelOnRender = true;
	    return _this;
	  }
	
	  _createClass(BusinessModelView, [{
	    key: "render",
	    value: function render() {
	      _get(BusinessModelView.prototype.__proto__ || Object.getPrototypeOf(BusinessModelView.prototype), "render", this).call(this);
	
	      this.rendered = false;
	
	      this.$element.find(".bm-action__data.bm-data__budget").prop("disabled", true);
	      this.$element.find(".bm-action__data.bm-data__points").prop("disabled", true);
	
	      this.$loader = this.$element.find(".business-model__loader");
	      this.$businessModelCanvas = this.$element.find(".bm__canvas");
	      this.$scoreScreenContainer = this.$element.find(".bm__score-screen");
	      this.$investmentsSlider = this.$element.find(".bm__investment-slider");
	      this.$actionBarWrapper = this.$element.find(".action-bar__wrapper");
	      this.$actionBarMain = this.$element.find(".action-bar.action-bar__main");
	      this.$actionBarPreview = this.$element.find(".action-bar.action-bar__preview");
	      this.$actionBarFaq = this.$element.find(".action-bar.action-bar__faq");
	
	      this.setActionBarVisible(false);
	
	      this.renderBusinessModelCanvas();
	      this.renderScoreScreen();
	      this.renderInvestmentsCarousel();
	      this.renderInvestmentDialog();
	      this.renderCloseRoundDialog();
	      this.renderTutorialDialog();
	      this.renderEventDialog();
	      this.renderExampleCasesDialog();
	      this.renderInvestmentExtraDialog();
	      this.renderFaqDialog();
	      this.renderGameBonusDialog();
	      this.renderLoanDialog();
	
	      this.renderBudgetHistory();
	      this.renderPointsHistory();
	
	      this.showBusinessModel(false);
	      this.showLoader(true);
	
	      this._setUpEventListeners();
	    }
	  }, {
	    key: "onRender",
	    value: function onRender() {
	      _get(BusinessModelView.prototype.__proto__ || Object.getPrototypeOf(BusinessModelView.prototype), "onRender", this).call(this);
	
	      log.info("Business model has rendered");
	
	      this.rendered = true;
	
	      this.refreshRoundData();
	
	      if (this.showBusinessModelOnRender) {
	        this.showBusinessModel(true, false);
	      }
	
	      // if(this.roundOverview.currentRoundData.roundIndex === 1 && utils.isNull(this.roundOverview.currentRoundData.closed))
	      // {
	      //   this.showTutorialDialog();
	      // }
	
	      this.setActionBarVisible(true);
	      this.$element.find(".bm-action__data.bm-data__budget").prop("disabled", false);
	      this.$element.find(".bm-action__data.bm-data__points").prop("disabled", false);
	
	      for (var i = 0; i < this.executeOnRender.length; i++) {
	        if (_utils2.default.isFunction(this.executeOnRender[i])) {
	          this.executeOnRender[i].call(this);
	        }
	      }
	
	      if (_utils2.default.isFunction(this.onRenderCompleted)) {
	        this.onRenderCompleted.call(this);
	      }
	    }
	  }, {
	    key: "renderBusinessModelCanvas",
	    value: function renderBusinessModelCanvas() {
	      var _this2 = this;
	
	      this.businessModel = new _businessModel4.default({
	        containerElement: this.$businessModelCanvas,
	        layoutData: _default2.default,
	        onRenderComplete: function onRenderComplete() {
	          _this2.businessModel.income = _this2.roundOverview.currentRoundData.currentIncome;
	          _this2.businessModel.setUpBeginState();
	          _this2.onRender();
	        },
	        onFaqClick: function onFaqClick(faqInfo) {
	          log.info("Clicked on faq item - %o", faqInfo);
	          _this2.showFaqDialog(faqInfo.faqType);
	        }
	      });
	
	      log.info("Rendering business model: %o", this.businessModel);
	
	      this.businessModel.render();
	    }
	  }, {
	    key: "renderScoreScreen",
	    value: function renderScoreScreen() {
	      if (_utils2.default.isNotNull(this.scoreScreen)) {
	        this.scoreScreen.destroy();
	      }
	
	      this.scoreScreen = new _scoreScreen2.default({
	        container: this.$scoreScreenContainer,
	        team: this.team,
	        teams: this.gameSession.teamList,
	        callbackContext: this,
	        onTeamScoreClick: this.onTeamScoreClick
	      });
	
	      this.scoreScreen.render();
	    }
	  }, {
	    key: "renderInvestmentsCarousel",
	    value: function renderInvestmentsCarousel() {
	      var _this3 = this;
	
	      if (_utils2.default.isNotNull(this.investmentSlider)) {
	        this.investmentSlider.destroy();
	      }
	
	      this.investmentSlider = new _investmentSlider2.default({
	        container: this.$investmentsSlider,
	        team: this.team,
	        roundOverview: this.roundOverview,
	        investments: this.caseWrapper.investments,
	        onInvestmentClicked: function onInvestmentClicked(investment) {
	          return _this3.onInvestmentClicked(investment);
	        }
	      });
	
	      this.investmentSlider.render();
	    }
	  }, {
	    key: "renderInvestmentDialog",
	    value: function renderInvestmentDialog() {
	      if (_utils2.default.isNotNull(this.investmentDialog)) {
	        this.investmentDialog.destroy();
	      }
	
	      this.investmentDialog = new _investmentDialog2.default({
	        team: this.team,
	        roundOverview: this.roundOverview,
	        investments: this.caseWrapper.investments,
	        callbackContext: this,
	        onCancel: this.onInvestmentDialogCancel,
	        onViewExampleCases: this.onInvestmentViewExamples,
	        onPreview: this.onInvestmentShowPreview,
	        onPurchase: this.onInvestmentPurchased
	      });
	
	      this.investmentDialog.create();
	    }
	  }, {
	    key: "renderCloseRoundDialog",
	    value: function renderCloseRoundDialog() {
	      if (_utils2.default.isNotNull(this.closeRoundDialog)) {
	        this.closeRoundDialog.destroy();
	      }
	
	      this.closeRoundDialog = new _closeRoundDialog2.default({
	        roundOverview: this.roundOverview,
	        callbackContext: this,
	        onCancel: this.onCloseRoundDialogCancel,
	        onViewInvestments: this.onViewInvestments,
	        onCloseRound: this.closeRound
	      });
	
	      this.closeRoundDialog.create();
	    }
	  }, {
	    key: "renderTutorialDialog",
	    value: function renderTutorialDialog() {
	      if (_utils2.default.isNotNull(this.tutorialDialog)) {
	        this.tutorialDialog.destroy();
	      }
	
	      this.tutorialDialog = new _tutorialDialog2.default({
	        callbackContext: this,
	        onCancel: this.onTutorialCancel
	      });
	
	      this.tutorialDialog.create();
	    }
	  }, {
	    key: "renderEventDialog",
	    value: function renderEventDialog() {
	      if (_utils2.default.isNotNull(this.eventDialog)) {
	        this.eventDialog.destroy();
	      }
	
	      this.eventDialog = new _eventDialog2.default({
	        callbackContext: this,
	        onCancel: this.onEventDialogCancel
	      });
	
	      this.eventDialog.create();
	    }
	  }, {
	    key: "renderExampleCasesDialog",
	    value: function renderExampleCasesDialog() {
	      if (_utils2.default.isNotNull(this.exampleCasesDialog)) {
	        this.exampleCasesDialog.destroy();
	      }
	
	      this.exampleCasesDialog = new _exampleCaseDialog2.default({
	        callbackContext: this,
	        onCancel: this.onExampleCaseDialogCancel
	      });
	
	      this.exampleCasesDialog.create();
	    }
	  }, {
	    key: "renderInvestmentExtraDialog",
	    value: function renderInvestmentExtraDialog() {
	      if (_utils2.default.isNotNull(this.investmentExtraDialog)) {
	        this.investmentExtraDialog.destroy();
	      }
	
	      this.investmentExtraDialog = new _investmentExtraDialog2.default({
	        callbackContext: this,
	        onCancel: this.onInvestmentExtraDialogCancel
	      });
	
	      this.investmentExtraDialog.create();
	    }
	  }, {
	    key: "renderFaqDialog",
	    value: function renderFaqDialog() {
	      if (_utils2.default.isNotNull(this.faqDialog)) {
	        this.faqDialog.destroy();
	      }
	
	      this.faqDialog = new _faqDialog2.default({
	        callbackContext: this,
	        onCancel: this.onFaqDialogCancel,
	        onViewInvestment: this.onViewInvestment
	      });
	
	      this.faqDialog.create();
	    }
	  }, {
	    key: "renderGameBonusDialog",
	    value: function renderGameBonusDialog() {
	      if (_utils2.default.isNotNull(this.gameBonusDialog)) {
	        this.gameBonusDialog.destroy();
	      }
	
	      this.gameBonusDialog = new _gameBonusDialog2.default({
	        callbackContext: this,
	        onCancel: this.onGameBonusDialogCancel
	      });
	
	      this.gameBonusDialog.create();
	    }
	  }, {
	    key: "renderLoanDialog",
	    value: function renderLoanDialog() {
	      if (_utils2.default.isNotNull(this.loanDialog)) {
	        this.loanDialog.destroy();
	      }
	
	      this.loanDialog = new _loanDialog2.default({
	        callbackContext: this,
	        onCancel: this.onLoanDialogCancel,
	        onRequestLoan: this.requestLoan
	      });
	
	      this.loanDialog.create();
	    }
	  }, {
	    key: "renderBudgetHistory",
	    value: function renderBudgetHistory() {
	      this.budgetHistoryComponent = new _dataHistory2.default({
	        triggerElement: this.$element.find(".bm-action__data.bm-data__budget")
	      });
	
	      this.budgetHistoryComponent.create();
	    }
	  }, {
	    key: "renderPointsHistory",
	    value: function renderPointsHistory() {
	      this.pointsHistoryComponent = new _dataHistory2.default({
	        triggerElement: this.$element.find(".bm-action__data.bm-data__points")
	      });
	
	      this.pointsHistoryComponent.create();
	    }
	  }, {
	    key: "renderGameProgressController",
	    value: function renderGameProgressController() {
	      var _this4 = this;
	
	      if (_utils2.default.isNotNull(this.gameProgressController)) {
	        this.gameProgressController.destroy();
	      }
	
	      this.gameProgressController = new _gameProgressController2.default({
	        container: this.$element.find(".business-model__progress-view"),
	        onRenderComplete: function onRenderComplete() {
	          _this4.gameProgressController.update();
	        }
	      });
	
	      log.info("Rendering game progress controller: %o", this.gameProgressController);
	
	      this.gameProgressController.render();
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      _get(BusinessModelView.prototype.__proto__ || Object.getPrototypeOf(BusinessModelView.prototype), "hide", this).call(this);
	
	      if (_utils2.default.isNotNull(this.investmentDialog)) {
	        this.removeBackdrop();
	
	        // Also hide dialogs when hiding the game view!
	        this.hideAllDialogs();
	      }
	    }
	  }, {
	    key: "hideAllDialogs",
	    value: function hideAllDialogs() {
	      this.hideInvestmentDialog(false);
	      this.hideInvestmentExamplesDialog(false);
	      this.hideInvestmentExtraDialog(false);
	      this.hideCloseRoundDialog(false);
	      this.hideEventDialog(false);
	      this.hideTutorialDialog(false);
	      this.hideFaqDialog(false);
	      this.hideGameBonusDialog(false);
	      this.hideLoanDialog(false);
	    }
	  }, {
	    key: "showBusinessModel",
	    value: function showBusinessModel(flag, hideOthers, removePreview) {
	      if (flag) {
	        if (hideOthers !== false) {
	          this.hideAllDialogs();
	          this.hideInvestments();
	          this.hideScoreScreen();
	        }
	
	        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	        this.$element.find(".bm-action-btn__model").addClass("bm-action__active");
	
	        this.removeBackdrop();
	
	        if (this.businessModel.hasRendered()) {
	          if (removePreview !== false) {
	            this.hidePreview();
	          }
	          this.hideFaq();
	
	          this.showLoader(false);
	          this.$businessModelCanvas.show();
	
	          // if(utils.isNotNull(this.hideCanvasAnimationTimeout))
	          // {
	          //   clearTimeout(this.hideCanvasAnimationTimeout);
	          //   this.hideCanvasAnimationTimeout = null;
	          // }
	          //
	          // this.$businessModelCanvas.show();
	          // this.$businessModelCanvas.addClass("bm__visible");
	        } else {
	          this.showBusinessModelOnRender = true;
	          this.showLoader(true);
	        }
	      } else {
	        // if(utils.isNotNull(this.hideCanvasAnimationTimeout))
	        // {
	        //   clearTimeout(this.hideCanvasAnimationTimeout);
	        //   this.hideCanvasAnimationTimeout = null;
	        // }
	        //
	        // this.$businessModelCanvas.removeClass("bm__visible");
	        // this.hideCanvasAnimationTimeout = setTimeout(() =>
	        // {
	        //   this.hideCanvasAnimationTimeout = null;
	        //   this.$businessModelCanvas.hide();
	        // }, CONSTANTS.BM_TRANSITION_SPEED);
	
	        this.$businessModelCanvas.hide();
	      }
	    }
	  }, {
	    key: "showLoader",
	    value: function showLoader(flag) {
	      if (flag) this.$loader.show();else this.$loader.hide();
	    }
	  }, {
	    key: "showScoreScreen",
	    value: function showScoreScreen(options) {
	      var _this5 = this;
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this5.showScoreScreen(options);
	        });
	        return;
	      }
	
	      var title = options.title,
	          roundIndex = options.roundIndex,
	          asOverlay = options.asOverlay === true;
	
	      this.scoreScreenMode = options.mode || "current-round";
	
	      this.scoreScreen.isFinal = this.scoreScreenMode === "endgame";
	      this.scoreScreen.title = title;
	      this.scoreScreen.roundIndex = roundIndex;
	      this.scoreScreen.team = this.team;
	      this.scoreScreen.roundOverview = this.roundOverview;
	      this.scoreScreen.interactive = options.interactive === true;
	
	      this.showLoader(false);
	      this.hideInvestments();
	      this.hideAllDialogs();
	
	      if (asOverlay) {
	        this.showBusinessModel(true, false);
	        this.$scoreScreenContainer.removeClass("bm__background-filled");
	        this.showBackdrop();
	      } else {
	        if (options.keepVisible === true) this.showBusinessModelOnRender = false;
	
	        if (options.hideBusinessModel !== false) {
	          this.showBusinessModel(false);
	        }
	
	        this.$scoreScreenContainer.addClass("bm__background-filled");
	        this.removeBackdrop();
	        this.setActionBarVisible(false);
	      }
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__score").addClass("bm-action__active");
	
	      this.scoreScreen.show(asOverlay);
	      this.$scoreScreenContainer.show().addClass("bm__visible");
	    }
	  }, {
	    key: "updateScoreScreen",
	    value: function updateScoreScreen() {
	      this.scoreScreen.team = this.team;
	      this.scoreScreen.roundOverview = this.roundOverview;
	      this.scoreScreen.update();
	    }
	  }, {
	    key: "updateTeamList",
	    value: function updateTeamList(teamList) {
	      this.gameSession.teamList = teamList;
	
	      if (_utils2.default.isNotNull(this.scoreScreen)) {
	        this.scoreScreen.updateTeamList(teamList);
	      }
	    }
	  }, {
	    key: "hideScoreScreen",
	    value: function hideScoreScreen(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.scoreScreen.hide();
	      this.$scoreScreenContainer.removeClass("bm__visible");
	      this.setActionBarVisible(true);
	    }
	  }, {
	    key: "showInvestments",
	    value: function showInvestments() {
	      log.debug("Showing investments slider");
	
	      this.showBusinessModel(true, true);
	
	      this.showBackdrop();
	
	      this.investmentSlider.show();
	
	      $("body").addClass("game__investments-open");
	      this.$investmentsSlider.show().addClass("bm__visible");
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);
	    }
	  }, {
	    key: "hideInvestments",
	    value: function hideInvestments(hideOverlay) {
	      if (hideOverlay) this.removeBackdrop();
	
	      $("body").removeClass("game__investments-open");
	      this.$investmentsSlider.removeClass("bm__visible");
	
	      this.investmentSlider.hide();
	
	      this.$element.find(".bm-action-btn__investments").removeClass("bm-action__active").prop("disabled", false);
	    }
	  }, {
	    key: "showInvestmentDialog",
	    value: function showInvestmentDialog(investment) {
	      if (this.investmentDialog.isOpen) {
	        return;
	      }
	
	      if (_utils2.default.isNotNull(investment)) this.investmentDialog.investment = investment;
	      if (_utils2.default.isNull(this.investmentDialog.investment)) return;
	
	      this.hideInvestmentExtraDialog(false);
	      this.hideInvestments();
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);
	
	      this.showBackdrop();
	      this.investmentDialog.team = this.team;
	      this.investmentDialog.roundOverview = this.roundOverview;
	      this.investmentDialog.show();
	    }
	  }, {
	    key: "hideInvestmentDialog",
	    value: function hideInvestmentDialog(removeBackdrop) {
	      if (_utils2.default.isNotNull(this.investmentDialog)) {
	        if (removeBackdrop !== false) {
	          this.removeBackdrop();
	        }
	
	        this.investmentDialog.hide();
	      }
	    }
	  }, {
	    key: "showInvestmentExamplesDialog",
	    value: function showInvestmentExamplesDialog(investment) {
	      var _this6 = this;
	
	      if (this.exampleCasesDialog.isOpen) {
	        return;
	      }
	
	      if (_utils2.default.isNull(investment)) return;
	
	      this.hideInvestmentExtraDialog(false);
	      this.hideInvestments();
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);
	
	      this.showBackdrop();
	      this.exampleCasesDialog.investment = investment;
	
	      this.executeOnExampleCasesClose.push(function () {
	        _this6.showInvestmentDialog(investment);
	      });
	
	      this.hideInvestmentDialog(false);
	      this.exampleCasesDialog.show();
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);
	    }
	  }, {
	    key: "hideInvestmentExamplesDialog",
	    value: function hideInvestmentExamplesDialog(removeBackdrop) {
	      if (_utils2.default.isNotNull(this.exampleCasesDialog)) {
	        if (removeBackdrop !== false) {
	          this.removeBackdrop();
	        }
	
	        this.exampleCasesDialog.hide();
	      }
	    }
	  }, {
	    key: "showPreview",
	    value: function showPreview(investment) {
	      var _this7 = this;
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this7.showPreview(investment);
	        });
	        return;
	      }
	
	      if (_utils2.default.isNotNull(investment)) {
	        this.showBusinessModel(true, true);
	
	        this.setUpPreviewResult(investment);
	
	        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	
	        this.showActionBar("preview");
	        this.businessModel.previewInvestment(investment.type);
	      }
	    }
	  }, {
	    key: "hidePreview",
	    value: function hidePreview() {
	      this.showActionBar("main");
	
	      this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;
	      this.businessModel.removePreview();
	    }
	  }, {
	    key: "showFaq",
	    value: function showFaq() {
	      var _this8 = this;
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this8.showFaq();
	        });
	        return;
	      }
	
	      this.showBusinessModel(true, true);
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__faq").addClass("bm-action__active");
	
	      this.showActionBar("faq");
	
	      if (!this.businessModel.faqIconsVisible) {
	        this.businessModel.toggleFaqIcons();
	      }
	    }
	  }, {
	    key: "hideFaq",
	    value: function hideFaq() {
	      if (this.businessModel.faqIconsVisible) {
	        this.businessModel.toggleFaqIcons();
	      }
	
	      this.showActionBar("main");
	    }
	  }, {
	    key: "showEventDialog",
	    value: function showEventDialog(moveActionBarBackwards, executeOnClose) {
	      var _this9 = this;
	
	      if (this.eventDialog.isOpen) {
	        return;
	      }
	
	      if (moveActionBarBackwards) {
	        this.setActionBarLayer(true);
	
	        this.executeOnEventClose.push(function () {
	          _this9.setActionBarLayer(false);
	        });
	      }
	
	      if (_utils2.default.isFunction(executeOnClose)) {
	        this.executeOnEventClose.push(executeOnClose);
	      }
	
	      this.showBusinessModel(true, true);
	      this.showBackdrop();
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__event").addClass("bm-action__active");
	
	      this.eventDialog.event = this.roundOverview.currentEvent;
	      this.eventDialog.show();
	    }
	  }, {
	    key: "hideEventDialog",
	    value: function hideEventDialog(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.eventDialog.hide();
	    }
	  }, {
	    key: "showCloseRoundDialog",
	    value: function showCloseRoundDialog() {
	      if (this.closeRoundDialog.isOpen) {
	        return;
	      }
	
	      this.showBusinessModel(true, true);
	      this.showBackdrop();
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	      this.$element.find(".bm-action-btn__close-round").addClass("bm-action__active");
	
	      this.closeRoundDialog.roundOverview = this.roundOverview;
	      this.closeRoundDialog.show();
	    }
	  }, {
	    key: "hideCloseRoundDialog",
	    value: function hideCloseRoundDialog(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.closeRoundDialog.hide();
	    }
	  }, {
	    key: "showTutorialDialog",
	    value: function showTutorialDialog(moveActionBarBackwards) {
	      var _this10 = this;
	
	      if (this.tutorialDialog.isOpen) {
	        return;
	      }
	
	      if (moveActionBarBackwards) {
	        this.setActionBarLayer(true);
	
	        this.executeOnTutorialClose.push(function () {
	          _this10.setActionBarLayer(false);
	        });
	      }
	
	      this.showBusinessModel(true, true);
	      this.showBackdrop();
	
	      this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	
	      this.tutorialDialog.show();
	    }
	  }, {
	    key: "hideTutorialDialog",
	    value: function hideTutorialDialog(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.tutorialDialog.hide();
	    }
	  }, {
	    key: "showInvestmentExtra",
	    value: function showInvestmentExtra(investmentType, data, moveActionBarBackwards, executeOnClose) {
	      var _this11 = this;
	
	      if (this.investmentExtraDialog.isOpen) {
	        return;
	      }
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this11.showInvestmentExtra(investmentType, data, moveActionBarBackwards, executeOnClose);
	        });
	        return;
	      }
	
	      var investment = null;
	
	      for (var i = 0; i < this.caseWrapper.investments.length; i++) {
	        if (this.caseWrapper.investments[i].type === investmentType) {
	          investment = this.caseWrapper.investments[i];
	        }
	      }
	
	      if (_utils2.default.isNotNull(investment)) {
	        if (moveActionBarBackwards) {
	          this.setActionBarLayer(true);
	
	          this.executeOnInvestmentExtraClose.push(function () {
	            _this11.setActionBarLayer(false);
	          });
	        }
	
	        if (_utils2.default.isFunction(executeOnClose)) {
	          this.executeOnInvestmentExtraClose.push(executeOnClose);
	        }
	
	        this.showBusinessModel(true, true);
	        this.showBackdrop();
	
	        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	
	        this.investmentExtraDialog.investment = investment;
	        this.investmentExtraDialog.extraData = data;
	        this.investmentExtraDialog.show();
	      }
	    }
	  }, {
	    key: "hideInvestmentExtraDialog",
	    value: function hideInvestmentExtraDialog(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.investmentExtraDialog.hide();
	    }
	  }, {
	    key: "showFaqDialog",
	    value: function showFaqDialog(faqType) {
	      var _this12 = this;
	
	      if (this.faqDialog.isOpen) {
	        return;
	      }
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this12.showFaqDialog(faqType);
	        });
	        return;
	      }
	
	      if (_utils2.default.isNotNull(this.faqDialog)) {
	        if (_utils2.default.isNull(faqType)) faqType = this.faqDialog.faqType;
	        if (_utils2.default.isNull(faqType)) return;
	
	        this.showFaq();
	        this.showBackdrop();
	
	        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	
	        this.faqDialog.faqItems = this.caseWrapper.faqList;
	        this.faqDialog.investments = this.caseWrapper.investments;
	        this.faqDialog.faqType = faqType;
	        this.faqDialog.show();
	      }
	    }
	  }, {
	    key: "hideFaqDialog",
	    value: function hideFaqDialog(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.faqDialog.hide();
	    }
	  }, {
	    key: "showGameBonusDialog",
	    value: function showGameBonusDialog(bonusType, bonusValue) {
	      var _this13 = this;
	
	      if (this.gameBonusDialog.isOpen) {
	        return;
	      }
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this13.showGameBonusDialog(bonusType, bonusValue);
	        });
	        return;
	      }
	
	      if (_utils2.default.isNotNull(this.gameBonusDialog)) {
	        this.showBusinessModel(true, true);
	        this.showBackdrop();
	
	        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	
	        this.gameBonusDialog.circular = bonusType === "circular-bonus";
	        this.gameBonusDialog.bonus = bonusValue;
	        this.gameBonusDialog.show();
	      }
	    }
	  }, {
	    key: "hideGameBonusDialog",
	    value: function hideGameBonusDialog(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.gameBonusDialog.hide();
	    }
	  }, {
	    key: "showLoanDialog",
	    value: function showLoanDialog(type, moveActionBarBackwards, executeOnClose) {
	      var _this14 = this;
	
	      if (this.loanDialog.isOpen) {
	        return;
	      }
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this14.showLoanDialog(type, moveActionBarBackwards, executeOnClose);
	        });
	        return;
	      }
	
	      if (_utils2.default.isNotNull(this.loanDialog)) {
	        if (moveActionBarBackwards) {
	          this.setActionBarLayer(true);
	
	          this.executeOnLoanDialogClose.push(function () {
	            _this14.setActionBarLayer(false);
	          });
	        }
	
	        if (_utils2.default.isFunction(executeOnClose)) {
	          this.executeOnLoanDialogClose.push(executeOnClose);
	        }
	
	        this.showBusinessModel(true, true);
	        this.showBackdrop();
	
	        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
	
	        this.loanDialog.roundOverview = this.roundOverview;
	        this.loanDialog.type = type;
	        this.loanDialog.show();
	      }
	    }
	  }, {
	    key: "hideLoanDialog",
	    value: function hideLoanDialog(removeBackdrop) {
	      if (removeBackdrop !== false) {
	        this.removeBackdrop();
	      }
	
	      this.loanDialog.hide();
	    }
	  }, {
	    key: "showBudgetHistory",
	    value: function showBudgetHistory() {
	      var _this15 = this;
	
	      if (!this.rendered) {
	        this.executeOnRender.push(function () {
	          return _this15.showBudgetHistory();
	        });
	        return;
	      }
	
	      this.budgetHistoryComponent.show();
	    }
	  }, {
	    key: "refreshRoundData",
	    value: function refreshRoundData() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.setActionButtonState();
	
	        // Update business model
	        if (_utils2.default.isNotNull(this.businessModel)) {
	          this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;
	
	          var teamInvestments = this.getInvestmentObjectsForTeam();
	          teamInvestments = teamInvestments.map(function (ti) {
	            return ti.type;
	          });
	          this.businessModel.updateInvestments(teamInvestments);
	
	          var productIcon = null;
	          var extraProductIcon = null;
	
	          for (var i = 0; i < this.caseWrapper.icons.length; i++) {
	            var icon = this.caseWrapper.icons[i];
	
	            if (icon.type === "product") {
	              productIcon = icon;
	            } else if (_utils2.default.isNotNull(this.roundOverview.currentRoundData.extraProductId) && this.roundOverview.currentRoundData.extraProductId === icon.type) {
	              extraProductIcon = icon;
	            }
	          }
	
	          if (_utils2.default.isNotNull(productIcon)) {
	            this.businessModel.setCompanyIcon(productIcon.value);
	          }
	
	          if (_utils2.default.isNotNull(extraProductIcon)) {
	            this.businessModel.setCompanyExtraProduct(extraProductIcon.value);
	          }
	        }
	
	        // Update investments slider
	        this.investmentSlider.team = this.team;
	        this.investmentSlider.investments = this.caseWrapper.investments;
	        this.investmentSlider.roundOverview = this.roundOverview;
	
	        // Update investment dialog
	        this.investmentDialog.team = this.team;
	        this.investmentDialog.investments = this.caseWrapper.investments;
	        this.investmentDialog.roundOverview = this.roundOverview;
	        this.investmentDialog.renderDialogContent();
	
	        // Update event dialog
	        if (_utils2.default.isNotNull(this.roundOverview.currentEvent)) {
	          this.eventDialog.event = this.roundOverview.currentEvent;
	        }
	
	        // Update score screen
	        this.scoreScreen.roundOverview = this.roundOverview;
	
	        if (this.scoreScreenMode === "previous-round") this.scoreScreen.roundIndex = this.roundOverview.currentRoundData.roundIndex - 1;else this.scoreScreen.roundIndex = null;
	
	        this.updateScoreScreen();
	      }
	    }
	  }, {
	    key: "setRoundOverview",
	    value: function setRoundOverview(roundOverview) {
	      this.roundOverview = roundOverview;
	      this.refreshRoundData();
	    }
	  }, {
	    key: "showActionBar",
	    value: function showActionBar(name) {
	      this.hideActionBars();
	
	      switch (name) {
	        case "faq":
	          this.$actionBarFaq.show();
	          break;
	        case "preview":
	          this.$actionBarPreview.show();
	          break;
	        case "main":
	        default:
	          this.$actionBarMain.show();
	      }
	    }
	  }, {
	    key: "hideActionBars",
	    value: function hideActionBars() {
	      this.$actionBarMain.hide();
	      this.$actionBarPreview.hide();
	      this.$actionBarFaq.hide();
	    }
	  }, {
	    key: "setActionButtonState",
	    value: function setActionButtonState() {
	      this.$element.find("[data-bm-current-budget]").text(this.roundOverview.currentRoundData.currentBudget);
	      this.$element.find("[data-bm-current-points]").text(this.roundOverview.currentRoundData.currentPoints);
	
	      this.budgetHistoryComponent.setComponentHtml(this.roundOverview, "budget");
	      this.pointsHistoryComponent.setComponentHtml(this.roundOverview, "points");
	
	      var investmentCount = 2;
	      if (_utils2.default.isNotNull(this.roundOverview.currentRoundData.investmentKey1)) investmentCount--;
	      if (_utils2.default.isNotNull(this.roundOverview.currentRoundData.investmentKey2)) investmentCount--;
	      this.$element.find(".bm-investment-count").text(investmentCount);
	
	      var previousRoundScore = this.getRoundScore(this.roundOverview.currentRoundData.roundIndex - 1);
	      var hasPreviousRoundScore = _utils2.default.isNotNull(previousRoundScore) && previousRoundScore.round !== 0;
	
	      if (hasPreviousRoundScore) {
	        this.$element.find(".bm-action-btn__score").show();
	      } else {
	        this.$element.find(".bm-action-btn__score").hide();
	      }
	
	      if (_utils2.default.isNotNull(this.roundOverview.currentEvent)) {
	        this.$element.find(".bm-action-btn__event").prop("disabled", false).show();
	      } else {
	        this.$element.find(".bm-action-btn__event").prop("disabled", true).hide();
	      }
	
	      if (this.roundOverview.currentRoundData.canLoan) {
	        this.$element.find(".bm-action-btn__loan").show();
	      } else {
	        this.$element.find(".bm-action-btn__loan").hide();
	      }
	    }
	  }, {
	    key: "setUpPreviewResult",
	    value: function setUpPreviewResult(previewInvestment) {
	      var investmentCost = _investmentSlider2.default.getCostForInvestment(this.roundOverview, previewInvestment);
	      var previewBudget = this.roundOverview.currentRoundData.currentBudget - investmentCost;
	
	      if (previewInvestment.type === "subsidy") {
	        this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;
	        previewBudget += previewInvestment.income;
	      } else {
	        this.businessModel.income = this.roundOverview.currentRoundData.currentIncome + previewInvestment.income;
	
	        if (previewInvestment.income > 0) {
	          this.businessModel.setIncomeIconTheme("positive", false);
	        } else if (previewInvestment.income < 0) {
	          this.businessModel.setIncomeIconTheme("negative", false);
	        } else {
	          this.businessModel.setIncomeIconTheme(null, false);
	        }
	      }
	
	      this.$element.find("[data-bm-preview-budget]").text(previewBudget);
	      this.$element.find("[data-bm-preview-points]").text(this.roundOverview.currentRoundData.currentPoints + previewInvestment.points);
	    }
	  }, {
	    key: "setActionBarVisible",
	    value: function setActionBarVisible(flag) {
	      if (flag) {
	        this.$actionBarWrapper.removeClass("visibility-hidden");
	      } else {
	        this.$actionBarWrapper.addClass("visibility-hidden");
	      }
	    }
	  }, {
	    key: "setActionBarLayer",
	    value: function setActionBarLayer(behindOverlay) {
	      if (behindOverlay) {
	        this.$actionBarWrapper.addClass("ab__back");
	      } else {
	        this.$actionBarWrapper.removeClass("ab__back");
	      }
	    }
	  }, {
	    key: "showEndGameView",
	    value: function showEndGameView(endGameData) {
	      var _this16 = this;
	
	      if (!this.rendered) {
	        this.showBusinessModelOnRender = false;
	        this.executeOnRender.push(function () {
	          return _this16.showEndGameView(endGameData);
	        });
	        return;
	      }
	
	      this.endGameData = endGameData;
	
	      this.$element.find(".business-model-wrapper").addClass("bm__mode-progress");
	
	      this.$element.find("[data-bm-team-overview-back]").addClass("visibility-hidden");
	      this.$element.find(".bm__mode-progress").addClass("visibility-hidden");
	      this.showScoreScreen({
	        mode: "endgame",
	        title: _languageManager2.default.getValueForKey("serious_game.business_model.score_screen.title.end_score"),
	        currentTeam: this.team,
	        roundOverview: this.roundOverview,
	        interactive: true,
	        hideBusinessModel: false
	      });
	    }
	  }, {
	    key: "showTeamGameOverview",
	    value: function showTeamGameOverview(teamName) {
	      if (_utils2.default.isNull(this.gameProgressController)) {
	        this.renderGameProgressController();
	      }
	
	      if (_utils2.default.isNotNull(this.endGameData)) {
	        var teamEndData = void 0;
	
	        for (var i = 0; i < this.endGameData.teams.length; i++) {
	          if (this.endGameData.teams[i].teamName === teamName) {
	            teamEndData = this.endGameData.teams[i];
	            break;
	          }
	        }
	
	        if (_utils2.default.isNotNull(teamEndData)) {
	          this.$element.find("[data-bm-team-overview-back]").removeClass("visibility-hidden");
	          this.$element.find(".bm__mode-progress").removeClass("visibility-hidden");
	
	          this.gameProgressController.roundIndex = 1;
	          this.gameProgressController.roundProgressMap = teamEndData.roundProgress;
	          this.gameProgressController.update();
	
	          this.hideScoreScreen(false);
	
	          if (_utils2.default.isFunction(this.onTeamOverviewChanged)) {
	            this.onTeamOverviewChanged.call(this, teamEndData);
	          }
	        }
	      } else {
	        log.error("Trying to set up game overview without endGameData");
	      }
	    }
	
	    // ==============================================
	    //                    ACTIONS
	    // ==============================================
	
	  }, {
	    key: "purchaseInvestment",
	    value: function purchaseInvestment(investment) {
	      var _this17 = this;
	
	      if (investment.type === "extraproduct") {
	        var extraProductIcons = [];
	
	        for (var i = 0; i < this.caseWrapper.icons.length; i++) {
	          if (this.caseWrapper.icons[i].type.includes("extension")) {
	            extraProductIcons.push(this.caseWrapper.icons[i]);
	          }
	        }
	
	        this.investmentExtraDialog.onExtraProductSelected = function (extraProductId) {
	          _this17.executeOnInvestmentExtraClose = [];
	          _this17.investmentExtraDialog.disableProductButtons(true);
	
	          if (_utils2.default.isFunction(_this17.onInvestmentAdded)) {
	            _this17.onInvestmentAdded.call(_this17, investment, extraProductId);
	          }
	        };
	        this.executeOnInvestmentExtraClose = [function () {
	          _this17.showInvestmentDialog(investment);
	        }];
	
	        this.hideInvestmentDialog(false);
	        this.showInvestmentExtra(investment.type, { extraProductIcons: extraProductIcons });
	      } else {
	        this.investmentDialog.setPurchaseButtonLoading(true);
	
	        if (_utils2.default.isFunction(this.onInvestmentAdded)) {
	          this.onInvestmentAdded.call(this, investment);
	        }
	      }
	    }
	  }, {
	    key: "closeRound",
	    value: function closeRound() {
	      log.info("Closing round [%d]", this.roundOverview.currentRoundData.roundIndex);
	
	      this.closeRoundDialog.setCloseRoundButtonLoading(true);
	
	      if (_utils2.default.isFunction(this.onTeamClosedRound)) {
	        this.onTeamClosedRound.call(this);
	      }
	    }
	  }, {
	    key: "requestLoan",
	    value: function requestLoan() {
	      log.info("Requesting loan in round [%d]", this.roundOverview.currentRoundData.roundIndex);
	
	      this.loanDialog.setRequestLoanButtonLoading(true);
	
	      if (_utils2.default.isFunction(this.onTeamRequestedLoan)) {
	        this.onTeamRequestedLoan.call(this);
	      }
	    }
	
	    // ==============================================
	    //                    UTILS
	    // ==============================================
	
	  }, {
	    key: "getRoundScore",
	    value: function getRoundScore(roundIndex) {
	      if (_utils2.default.isNull(this.roundOverview) || _utils2.default.isNull(this.roundOverview.commonDataSelf.roundScores)) return null;
	
	      for (var i = 0; i < this.roundOverview.commonDataSelf.roundScores.length; i++) {
	        var roundScore = this.roundOverview.commonDataSelf.roundScores[i];
	        if (roundScore.round === roundIndex) {
	          return roundScore;
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getInvestmentObjectsForTeam",
	    value: function getInvestmentObjectsForTeam() {
	      var investments = [];
	
	      for (var roundIndex in this.team.roundData) {
	        if (this.team.roundData.hasOwnProperty(roundIndex)) {
	          var roundData = this.team.roundData[roundIndex];
	
	          for (var i = 0; i < this.caseWrapper.investments.length; i++) {
	            var investment = this.caseWrapper.investments[i];
	
	            if (_utils2.default.isNotNull(roundData.investmentKey1) && investment.key === roundData.investmentKey1) {
	              investments.push(investment);
	            }
	
	            if (_utils2.default.isNotNull(roundData.investmentKey2) && investment.key === roundData.investmentKey2) {
	              investments.push(investment);
	            }
	          }
	        }
	      }
	
	      return investments;
	    }
	
	    // ==============================================
	    //                    EVENTS
	    // ==============================================
	
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      this.$element.find(".bm-action-btn__score").off("click").on("click", this.onShowScoreScreen.bind(this));
	
	      this.$element.find(".bm-action-btn__model").off("click").on("click", this.onShowBusinessModel.bind(this));
	
	      this.$element.find(".bm-action-btn__investments").off("click").on("click", this.onShowInvestments.bind(this));
	
	      this.$element.find(".bm-action-btn__faq").off("click").on("click", this.onShowHelp.bind(this));
	
	      this.$element.find(".bm-action-btn__event").off("click").on("click", this.onShowEvent.bind(this));
	
	      this.$element.find(".bm-action-btn__loan").off("click").on("click", this.onShowRequestLoan.bind(this));
	
	      this.$element.find(".bm-action-btn__close-round").off("click").on("click", this.onCloseRound.bind(this));
	
	      this.$element.find(".close-preview-btn").off("click").on("click", this.onClosePreview.bind(this));
	
	      this.$element.find(".show-tutorial-btn").off("click").on("click", this.onShowTutorial.bind(this));
	      this.$element.find(".close-faq-btn").off("click").on("click", this.onCloseFaq.bind(this));
	
	      this.$element.find(".back-to-score-btn").off("click").on("click", this.onCloseTeamOverview.bind(this));
	    }
	  }, {
	    key: "pulsateEventButton",
	    value: function pulsateEventButton() {
	      log.info("Pulsating event button (possible delay)");
	
	      this.$element.find(".bm-action-btn__event").removeClass("bounce animated").addClass("bounce animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
	        $(this).removeClass("bounce animated");
	      });
	    }
	  }, {
	    key: "pulsateLoanButton",
	    value: function pulsateLoanButton() {
	      log.info("Pulsating event button (possible delay)");
	
	      this.$element.find(".bm-action-btn__loan").removeClass("bounce animated").addClass("bounce animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
	        $(this).removeClass("bounce animated");
	      });
	    }
	  }, {
	    key: "onShowScoreScreen",
	    value: function onShowScoreScreen(e) {
	      log.info("Click on show score screen");
	      this.showScoreScreen({
	        currentTeam: this.team,
	        title: _utils2.default.format(_languageManager2.default.getValueForKey("serious_game.business_model.score_screen.title.round_result"), this.roundOverview.currentRoundData.roundIndex - 1),
	        roundOverview: this.roundOverview,
	        roundIndex: this.roundOverview.currentRoundData.roundIndex - 1,
	        asOverlay: true,
	        mode: "previous-round"
	      });
	    }
	  }, {
	    key: "onShowBusinessModel",
	    value: function onShowBusinessModel(e) {
	      log.info("Click on show business model");
	      this.showBusinessModel(true);
	    }
	  }, {
	    key: "onShowInvestments",
	    value: function onShowInvestments(e) {
	      log.info("Clicked on show investments");
	      this.showInvestments();
	    }
	  }, {
	    key: "onInvestmentClicked",
	    value: function onInvestmentClicked(investment) {
	      log.info("Clicked on investment - %o", investment);
	      this.showInvestmentDialog(investment);
	    }
	  }, {
	    key: "onShowHelp",
	    value: function onShowHelp(e) {
	      log.info("Click on show faq");
	      this.showFaq();
	    }
	  }, {
	    key: "onShowEvent",
	    value: function onShowEvent(e) {
	      log.info("Click on show event");
	      this.showEventDialog();
	    }
	  }, {
	    key: "onShowRequestLoan",
	    value: function onShowRequestLoan(e) {
	      log.info("Click on request loan");
	      this.showLoanDialog("request-loan");
	    }
	  }, {
	    key: "onCloseRound",
	    value: function onCloseRound(e) {
	      log.info("Click on close round");
	      this.showCloseRoundDialog();
	    }
	  }, {
	    key: "onClosePreview",
	    value: function onClosePreview(e) {
	      log.info("Click on close preview");
	      this.showInvestmentDialog();
	      this.hidePreview();
	    }
	  }, {
	    key: "onShowTutorial",
	    value: function onShowTutorial(e) {
	      log.info("Click on show tutorial");
	      this.showTutorialDialog(false);
	    }
	  }, {
	    key: "onCloseFaq",
	    value: function onCloseFaq(e) {
	      log.info("Click on close faq");
	      this.hideFaq();
	      this.showBusinessModel(true, true);
	    }
	  }, {
	    key: "onInvestmentDialogCancel",
	    value: function onInvestmentDialogCancel(investmentDialog) {
	      log.info("Investment [%s] cancelled", investmentDialog.investment.type);
	      this.showInvestments();
	
	      if (_utils2.default.isArray(this.executeOnInvestmentClose)) {
	        // Make copy and clear original
	        var executeCopy = this.executeOnInvestmentClose.splice(0);
	
	        for (var i = 0; i < executeCopy.length; i++) {
	          executeCopy[i].call(this);
	        }
	      }
	    }
	  }, {
	    key: "onInvestmentViewExamples",
	    value: function onInvestmentViewExamples(investmentDialog) {
	      log.info("Investment [%s] - requesting examples", investmentDialog.investment.type);
	      this.showInvestmentExamplesDialog(investmentDialog.investment);
	    }
	  }, {
	    key: "onInvestmentShowPreview",
	    value: function onInvestmentShowPreview(investmentDialog) {
	      log.info("Investment [%s] - requesting preview", investmentDialog.investment.type);
	      this.showPreview(investmentDialog.investment);
	    }
	  }, {
	    key: "onInvestmentPurchased",
	    value: function onInvestmentPurchased(investmentDialog) {
	      log.info("Investment [%s] - purchasing", investmentDialog.investment.type);
	      this.purchaseInvestment(investmentDialog.investment);
	    }
	  }, {
	    key: "onCloseRoundDialogCancel",
	    value: function onCloseRoundDialogCancel() {
	      log.info("Cancelled close round dialog");
	      this.hideCloseRoundDialog();
	    }
	  }, {
	    key: "onViewInvestments",
	    value: function onViewInvestments() {
	      log.info("Viewing investments");
	      this.showInvestments();
	    }
	  }, {
	    key: "onTutorialCancel",
	    value: function onTutorialCancel() {
	      log.info("Cancelled tutorial dialog");
	      this.hideTutorialDialog();
	      this.showBusinessModel(true, true);
	    }
	  }, {
	    key: "onEventDialogCancel",
	    value: function onEventDialogCancel() {
	      log.info("Cancelled event dialog");
	      this.showBusinessModel(true, true);
	
	      if (_utils2.default.isArray(this.executeOnEventClose)) {
	        // Make copy and clear original
	        var executeCopy = this.executeOnEventClose.splice(0);
	
	        for (var i = 0; i < executeCopy.length; i++) {
	          executeCopy[i].call(this);
	        }
	      }
	    }
	  }, {
	    key: "onInvestmentExtraDialogCancel",
	    value: function onInvestmentExtraDialogCancel() {
	      log.info("Cancelled investment extra dialog");
	      this.hideInvestmentExtraDialog(true);
	
	      if (_utils2.default.isArray(this.executeOnInvestmentExtraClose)) {
	        // Make copy and clear original
	        var executeCopy = this.executeOnInvestmentExtraClose.splice(0);
	
	        for (var i = 0; i < executeCopy.length; i++) {
	          executeCopy[i].call(this);
	        }
	      }
	    }
	  }, {
	    key: "onFaqDialogCancel",
	    value: function onFaqDialogCancel() {
	      log.info("Cancelled faq dialog");
	      this.hideFaqDialog(true);
	      this.showFaq();
	    }
	  }, {
	    key: "onViewInvestment",
	    value: function onViewInvestment(faqDialog, investment) {
	      var _this18 = this;
	
	      log.info("Viewing investment linked to faq item - %o", investment);
	      this.hideFaqDialog(false);
	
	      this.executeOnInvestmentClose.push(function () {
	        _this18.showFaqDialog();
	      });
	
	      this.showInvestmentDialog(investment);
	    }
	  }, {
	    key: "onGameBonusDialogCancel",
	    value: function onGameBonusDialogCancel() {
	      log.info("Cancelled game bonus dialog");
	      this.hideGameBonusDialog(true);
	      this.showBusinessModel(true, true);
	    }
	  }, {
	    key: "onExampleCaseDialogCancel",
	    value: function onExampleCaseDialogCancel() {
	      log.info("Cancelled example cases dialog");
	      this.hideInvestmentExamplesDialog(true);
	
	      if (_utils2.default.isArray(this.executeOnExampleCasesClose)) {
	        // Make copy and clear original
	        var executeCopy = this.executeOnExampleCasesClose.splice(0);
	
	        for (var i = 0; i < executeCopy.length; i++) {
	          executeCopy[i].call(this);
	        }
	      }
	    }
	  }, {
	    key: "onLoanDialogCancel",
	    value: function onLoanDialogCancel() {
	      log.info("Cancelled loan dialog");
	      this.hideLoanDialog(true);
	
	      if (_utils2.default.isArray(this.executeOnLoanDialogClose)) {
	        // Make copy and clear original
	        var executeCopy = this.executeOnLoanDialogClose.splice(0);
	
	        for (var i = 0; i < executeCopy.length; i++) {
	          executeCopy[i].call(this);
	        }
	      }
	    }
	  }, {
	    key: "onTeamScoreClick",
	    value: function onTeamScoreClick(e, teamName) {
	      log.info("Clicked on game overview in score screen for team [%s] - %o", teamName, e);
	      this.showTeamGameOverview(teamName);
	    }
	  }, {
	    key: "onCloseTeamOverview",
	    value: function onCloseTeamOverview(e) {
	      this.showEndGameView(this.endGameData);
	
	      if (_utils2.default.isFunction(this.onTeamOverviewClosed)) {
	        this.onTeamOverviewClosed.call(this);
	      }
	    }
	  }]);
	
	  return BusinessModelView;
	}(_gameView2.default);
	
	module.exports = BusinessModelView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _gameView = __webpack_require__(33);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _introduction = __webpack_require__(797);
	
	var _introduction2 = _interopRequireDefault(_introduction);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by jv on 2019-09-10 (14:33).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	__webpack_require__(751);
	
	var IntroductionView = function (_GameView) {
	  _inherits(IntroductionView, _GameView);
	
	  function IntroductionView(options) {
	    _classCallCheck(this, IntroductionView);
	
	    options.html = $(_introduction2.default);
	
	    var _this = _possibleConstructorReturn(this, (IntroductionView.__proto__ || Object.getPrototypeOf(IntroductionView)).call(this, options));
	
	    _this.path = "introduction";
	    _this.videoLink = options.videoLink;
	    _this.onIntroductionCompleted = options.onIntroductionCompleted;
	
	    _this.$video = null;
	    return _this;
	  }
	
	  _createClass(IntroductionView, [{
	    key: "render",
	    value: function render() {
	      _get(IntroductionView.prototype.__proto__ || Object.getPrototypeOf(IntroductionView.prototype), "render", this).call(this);
	      this.setUpVideo();
	      this._setUpEventListeners();
	
	      this.onRender();
	    }
	  }, {
	    key: "setUpVideo",
	    value: function setUpVideo() {
	      var _this2 = this;
	
	      this.$video = $("<video controls class='embed-responsive-item'></video>");
	      this.$video.append("<source src='" + this.videoLink + "' type=\"video/mp4\">");
	      this.$video.append(_utils2.default.format(_languageManager2.default.getValueForKey("global.video.unsupported"), this.videoLink));
	
	      this.$element.find(".introduction-video").append(this.$video);
	
	      this.$video.on("ended", function (e) {
	        if (_utils2.default.isFunction(_this2.onIntroductionCompleted)) {
	          _this2.onIntroductionCompleted.call(_this2, false);
	        }
	      });
	    }
	  }, {
	    key: "setLoadingState",
	    value: function setLoadingState(flag) {
	      var $skipBtn = this.$element.find(".skip-intro-btn");
	
	      $skipBtn.removeClass("btn-loading").prop("disabled", flag);
	
	      if (flag) {
	        $skipBtn.addClass("btn-loading");
	      }
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      var _this3 = this;
	
	      this.$element.find(".skip-intro-btn").off("click").on("click", function (e) {
	        _this3.$video.trigger("pause");
	
	        if (_utils2.default.isFunction(_this3.onIntroductionCompleted)) {
	          _this3.onIntroductionCompleted.call(_this3, true);
	        }
	      });
	    }
	  }]);
	
	  return IntroductionView;
	}(_gameView2.default);
	
	module.exports = IntroductionView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _gameView = __webpack_require__(33);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _quiz = __webpack_require__(798);
	
	var _quiz2 = _interopRequireDefault(_quiz);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _scoreScreen = __webpack_require__(291);
	
	var _scoreScreen2 = _interopRequireDefault(_scoreScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Created by jv on 2019-09-10 (14:32).
	 */
	var log = __webpack_require__(5)();
	
	
	__webpack_require__(753);
	
	var QuizView = function (_GameView) {
	  _inherits(QuizView, _GameView);
	
	  function QuizView(options) {
	    _classCallCheck(this, QuizView);
	
	    options.html = $(_quiz2.default);
	
	    var _this = _possibleConstructorReturn(this, (QuizView.__proto__ || Object.getPrototypeOf(QuizView)).call(this, options));
	
	    _this.path = "quiz";
	
	    _this.gameSession = options.gameSession;
	    _this.questions = options.questions;
	    _this.currentQuestion = _utils2.default.isNumber(options.currentQuestion) ? options.currentQuestion : 0;
	
	    _this.onQuestionAnswered = options.onQuestionAnswered;
	    return _this;
	  }
	
	  _createClass(QuizView, [{
	    key: "render",
	    value: function render() {
	      _get(QuizView.prototype.__proto__ || Object.getPrototypeOf(QuizView.prototype), "render", this).call(this);
	
	      this.$scoreScreenContainer = this.$element.find(".quiz-result-wrapper");
	
	      this.renderQuestions();
	      this.renderScoreScreen();
	      this._setUpEventListeners();
	
	      this.onRender();
	    }
	  }, {
	    key: "renderScoreScreen",
	    value: function renderScoreScreen() {
	      if (_utils2.default.isNotNull(this.scoreScreen)) {
	        this.scoreScreen.destroy();
	      }
	
	      this.scoreScreen = new _scoreScreen2.default({
	        container: this.$scoreScreenContainer,
	        title: _languageManager2.default.getValueForKey("serious_game.quiz.result.title"),
	        mode: "quiz",
	        team: this.gameSession.team,
	        teams: this.gameSession.teamList
	      });
	
	      this.scoreScreen.render();
	
	      this.scoreScreen.hideWaitingIndicators();
	    }
	  }, {
	    key: "renderQuestions",
	    value: function renderQuestions() {
	      this.$questionsWrapper = this.$element.find(".questions-wrapper");
	      var foundStartQuestion = false;
	
	      for (var i = 0; i < this.questions.length; i++) {
	        var $questionWrapper = QuizView.renderQuestion(this.questions[i]);
	        $questionWrapper.hide();
	
	        if (i === this.currentQuestion) {
	          foundStartQuestion = true;
	          $questionWrapper.show();
	        }
	
	        this.$questionsWrapper.append($questionWrapper);
	      }
	
	      if (!foundStartQuestion) {
	        this.$questionsWrapper.find(".question-wrapper").first().show();
	      }
	    }
	  }, {
	    key: "setCurrentQuestion",
	    value: function setCurrentQuestion(currentQuestionIndex) {
	      var _this2 = this;
	
	      this.$element.find(".quiz-waiting__loader").hide();
	
	      this.$questionsWrapper.find(".question-wrapper").each(function (index, el) {
	        var $questionWrapper = $(el);
	        var questionIndex = $questionWrapper.data("question-index");
	
	        if (currentQuestionIndex === questionIndex) {
	          _this2.currentQuestion = index;
	          $questionWrapper.find(".quiz__answer-btn").removeClass("btn-loading").prop("disabled", false);
	          $questionWrapper.show();
	        } else {
	          $questionWrapper.hide();
	        }
	      });
	    }
	  }, {
	    key: "showWaitingScreen",
	    value: function showWaitingScreen() {
	      this.$element.find(".quiz-waiting__loader").show();
	    }
	  }, {
	    key: "hideScoreScreen",
	    value: function hideScoreScreen() {
	      this.scoreScreen.hide();
	      this.$scoreScreenContainer.hide();
	
	      this.$element.find(".questions-wrapper").show();
	    }
	  }, {
	    key: "showScoreScreen",
	    value: function showScoreScreen(options) {
	      var currentTeam = options.currentTeam,
	          roundOverview = options.roundOverview;
	
	      this.scoreScreen.roundIndex = options.roundIndex;
	      this.scoreScreen.team = currentTeam;
	      this.scoreScreen.roundOverview = roundOverview;
	
	      this.$element.find(".quiz-waiting__loader").hide();
	      this.$element.find(".questions-wrapper").hide();
	
	      this.$scoreScreenContainer.show();
	      this.scoreScreen.show();
	    }
	  }, {
	    key: "updateScoreScreen",
	    value: function updateScoreScreen(options) {
	      var currentTeam = options.currentTeam,
	          roundOverview = options.roundOverview;
	
	      this.scoreScreen.roundIndex = options.roundIndex;
	      this.scoreScreen.team = currentTeam;
	      this.scoreScreen.roundOverview = roundOverview;
	      this.scoreScreen.update();
	    }
	  }, {
	    key: "updateTeamList",
	    value: function updateTeamList(teamList) {
	      this.gameSession.teamList = teamList;
	
	      if (_utils2.default.isNotNull(this.scoreScreen)) {
	        this.scoreScreen.updateTeamList(teamList);
	      }
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      var _this3 = this;
	
	      this.$questionsWrapper.find(".quiz__answer-btn").off("click").on("click", function (e) {
	        var $this = $(e.delegateTarget);
	        var questionIndex = $this.data("question-index");
	
	        if (questionIndex !== _this3.currentQuestion) {
	          log.error("Unexpected question order. Expected to get answer for question %d - but got answer for question %d instead", _this3.currentQuestion, questionIndex);
	        } else {
	          $this.closest(".question-wrapper").find(".quiz__answer-btn").addClass("btn-loading").prop("disabled", true);
	
	          var questionResult = $this.data("question-result");
	
	          if (_utils2.default.isFunction(_this3.onQuestionAnswered)) {
	            _this3.onQuestionAnswered.call(_this3, questionIndex, questionResult === 1);
	          }
	        }
	      });
	    }
	  }], [{
	    key: "renderQuestion",
	    value: function renderQuestion(question) {
	      var $questionWrapper = $("<div class='question-wrapper'></div>");
	      $questionWrapper.data("question-index", question.index);
	      $questionWrapper.append("<h5 class='question-title'>" + question.question + "</h5>");
	
	      var $row = $("<div class='row answer-row'></div>");
	      var $column1 = $("<div class='col-12 col-md-6'></div>").append(QuizView.renderAnswer(question.index, question.correctimage, question.correcttext, true));
	      var $column2 = $("<div class='col-12 col-md-6'></div>").append(QuizView.renderAnswer(question.index, question.wrongimage, question.wrongtext, false));
	
	      var random = _utils2.default.getRandomIntInclusive(1, 2);
	
	      if (random === 1) {
	        $row.append($column1).append($column2);
	      } else {
	        $row.append($column2).append($column1);
	      }
	
	      $questionWrapper.append($row);
	
	      return $questionWrapper;
	    }
	  }, {
	    key: "renderAnswer",
	    value: function renderAnswer(index, image, text, isCorrect) {
	      var $answer = $("<div class='answer-wrapper'></div>");
	      var $answerImageWrapper = $("<div class='answer__image-wrapper'></div>");
	      $answerImageWrapper.append("<img src=\"" + image + "\" alt=\"" + text + "\"/>");
	      $answer.append($answerImageWrapper);
	
	      var $answerButtonWrapper = $("<div class='answer__button-wrapper'></div>");
	      var $answerBtn = $("<button class='btn btn-c-light-blue btn-lg quiz__answer-btn' type='button'>" + text + "</button>");
	
	      $answerBtn.data("question-index", index);
	      $answerBtn.data("question-result", isCorrect ? 1 : 0);
	
	      $answerButtonWrapper.append($answerBtn);
	      $answer.append($answerButtonWrapper);
	
	      return $answer;
	    }
	  }]);
	
	  return QuizView;
	}(_gameView2.default);
	
	module.exports = QuizView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _gameView = __webpack_require__(33);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _reconnect = __webpack_require__(799);
	
	var _reconnect2 = _interopRequireDefault(_reconnect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Created by jv on 2020-01-06 (11:40).
	 */
	var log = __webpack_require__(5)();
	
	__webpack_require__(754);
	
	var ReconnectView = function (_GameView) {
	  _inherits(ReconnectView, _GameView);
	
	  function ReconnectView(options) {
	    _classCallCheck(this, ReconnectView);
	
	    options.html = $(_reconnect2.default);
	
	    var _this = _possibleConstructorReturn(this, (ReconnectView.__proto__ || Object.getPrototypeOf(ReconnectView)).call(this, options));
	
	    _this.path = "reconnect";
	    _this.sessionId = options.sessionId;
	    return _this;
	  }
	
	  _createClass(ReconnectView, [{
	    key: "render",
	    value: function render() {
	      _get(ReconnectView.prototype.__proto__ || Object.getPrototypeOf(ReconnectView.prototype), "render", this).call(this);
	      this._setUpEventListeners();
	
	      this.onRender();
	    }
	  }, {
	    key: "onRender",
	    value: function onRender() {
	      _get(ReconnectView.prototype.__proto__ || Object.getPrototypeOf(ReconnectView.prototype), "onRender", this).call(this);
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      var _this2 = this;
	
	      this.$element.find(".cancel-reconnect-btn").off("click").on("click", function (e) {
	        if (_utils2.default.isFunction(_this2.onCancelReconnect)) {
	          _this2.onCancelReconnect.call(_this2, $(_this2));
	        }
	      });
	    }
	  }, {
	    key: "setReconnectFailed",
	    value: function setReconnectFailed() {
	      if (this.hasRendered) {
	        this.$element.find(".reconnect-loader").hide();
	        this.$element.find(".reconnect-result").show();
	      }
	    }
	  }, {
	    key: "clearReconnectResult",
	    value: function clearReconnectResult() {
	      if (this.hasRendered) {
	        this.$element.find(".reconnect-loader").show();
	        this.$element.find(".reconnect-result").hide();
	      }
	    }
	  }]);
	
	  return ReconnectView;
	}(_gameView2.default);
	
	module.exports = ReconnectView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _gameView = __webpack_require__(33);
	
	var _gameView2 = _interopRequireDefault(_gameView);
	
	var _sessionJoin = __webpack_require__(800);
	
	var _sessionJoin2 = _interopRequireDefault(_sessionJoin);
	
	var _formValidator = __webpack_require__(24);
	
	var _formValidator2 = _interopRequireDefault(_formValidator);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Created by jv on 2019-09-10 (12:40).
	 */
	var log = __webpack_require__(5)();
	
	__webpack_require__(752);
	
	var SessionJoinView = function (_GameView) {
	  _inherits(SessionJoinView, _GameView);
	
	  function SessionJoinView(options) {
	    _classCallCheck(this, SessionJoinView);
	
	    options.html = $(_sessionJoin2.default);
	
	    var _this = _possibleConstructorReturn(this, (SessionJoinView.__proto__ || Object.getPrototypeOf(SessionJoinView)).call(this, options));
	
	    _this.path = "session-join";
	    _this.sessionId = options.sessionId;
	    return _this;
	  }
	
	  _createClass(SessionJoinView, [{
	    key: "render",
	    value: function render() {
	      _get(SessionJoinView.prototype.__proto__ || Object.getPrototypeOf(SessionJoinView.prototype), "render", this).call(this);
	      this._setUpEventListeners();
	
	      this.onRender();
	    }
	  }, {
	    key: "onRender",
	    value: function onRender() {
	      var _this2 = this;
	
	      _get(SessionJoinView.prototype.__proto__ || Object.getPrototypeOf(SessionJoinView.prototype), "onRender", this).call(this);
	
	      this.formValidator = new _formValidator2.default({
	        selector: this.$element.find(".join-session-form"),
	        validateOnChange: true,
	        rules: {
	          "session-id": {
	            required: true,
	            maxLength: 20,
	            validator: function validator(value) {
	              var regex = new RegExp("^[0-9]+$"); // only allow numeric (fontend check only)
	              return !_utils2.default.isNullOrEmpty(value) && value.trim() !== "" && regex.test(value);
	            }
	          },
	          "team-name": {
	            required: true,
	            maxLength: 20,
	
	            validator: function validator(value) {
	              var regex = new RegExp("^[a-zA-Z0-9\-_ ]+$"); // only allow alphanumeric, space, - and _ (keep in sync with GameSessionController.java)
	              return !_utils2.default.isNullOrEmpty(value) && value.trim() !== "" && regex.test(value);
	            },
	            tooltip: _languageManager2.default.getValueForKey("serious_game.session.form.session_name.tooltip"),
	            tooltipPlacement: "right"
	          }
	        }
	      });
	
	      this.formValidator.setValueForKey("session-id", this.sessionId);
	
	      if (false) {
	        $(window).on("keydown", function (e) {
	          if (e.ctrlKey) {
	            log.info(e.code);
	
	            if (e.code.startsWith("Digit") || e.code.startsWith("Numpad")) {
	              var num = e.code.replace("Digit", "");
	              num = num.replace("Numpad", "");
	              _this2.formValidator.setValueForKey("session-id", "123456");
	              _this2.formValidator.setValueForKey("team-name", "Team" + num);
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "getFormSessionId",
	    value: function getFormSessionId() {
	      if (_utils2.default.isNotNull(this.formValidator)) {
	        var formData = this.formValidator.getFormData();
	
	        return _utils2.default.isNotNull(formData) ? formData["session-id"] : null;
	      }
	
	      return null;
	    }
	  }, {
	    key: "getFormTeamName",
	    value: function getFormTeamName() {
	      if (_utils2.default.isNotNull(this.formValidator)) {
	        var formData = this.formValidator.getFormData();
	
	        return _utils2.default.isNotNull(formData) ? formData["team-name"] : null;
	      }
	
	      return null;
	    }
	  }, {
	    key: "showForm",
	    value: function showForm() {
	      this.$element.find(".join-session-form-wrapper").removeClass("loading");
	    }
	  }, {
	    key: "showLoadingState",
	    value: function showLoadingState() {
	      this.$element.find(".join-session-form-wrapper").addClass("loading");
	    }
	  }, {
	    key: "setJoinButtonLoading",
	    value: function setJoinButtonLoading(flag) {
	      _utils2.default.setButtonLoading(this.$element.find(".join-session-btn"), flag);
	    }
	  }, {
	    key: "setFormError",
	    value: function setFormError(errorMessage) {
	      this.clearFormErrors();
	      var $formError = $("<div class='form-error'></div>").text(errorMessage);
	      this.$element.find(".form-errors").append($formError);
	    }
	  }, {
	    key: "clearFormErrors",
	    value: function clearFormErrors() {
	      this.$element.find(".form-errors").empty();
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      var _this3 = this;
	
	      this.$element.find(".join-session-btn").off("click").on("click", function (e) {
	        var $this = $(e.delegateTarget);
	
	        _this3.clearFormErrors();
	        var isValid = _this3.formValidator.validate();
	
	        if (isValid) {
	          _this3.setJoinButtonLoading(true);
	
	          if (_utils2.default.isFunction(_this3.onJoinSession)) {
	            _this3.onJoinSession.call(_this3, $this);
	          }
	        }
	      });
	    }
	  }]);
	
	  return SessionJoinView;
	}(_gameView2.default);
	
	module.exports = SessionJoinView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 727:
47,

/***/ 729:
47,

/***/ 730:
47,

/***/ 732:
47,

/***/ 733:
47,

/***/ 734:
47,

/***/ 736:
47,

/***/ 737:
47,

/***/ 738:
47,

/***/ 739:
47,

/***/ 749:
47,

/***/ 751:
47,

/***/ 752:
47,

/***/ 753:
47,

/***/ 754:
47,

/***/ 762:
47,

/***/ 794:
/***/ (function(module, exports) {

	module.exports = "<div class=\"investments-container\">\n  <div class=\"investments__category-tabs\">\n    <button class=\"btn btn-link category-tab-btn category-active\" type=\"button\"\n            data-localize=\"serious_game.business_model.investments.categories.all\"\n            data-investment-category=\"all\"></button>\n    <button class=\"btn btn-link category-tab-btn\" type=\"button\"\n            data-localize=\"serious_game.business_model.investments.categories.available\"\n            data-investment-category=\"available\"></button>\n  </div>\n\n  <div class=\"investments__slider-wrapper\">\n\n    <button class=\"btn btn-slider btn-slider__prev investment-slider__arrow-prev\">\n      <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 4.4 6.6\"\n           xml:space=\"preserve\">\n        <path fill=\"none\" stroke=\"#699CD3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n              d=\"M0.8,0.8l2.5,2.5L0.8,5.8\"></path>\n      </svg>\n    </button>\n\n    <div class='investments__slider'>\n      <!--Generated-->\n    </div>\n\n    <button class=\"btn btn-slider btn-slider__next investment-slider__arrow-next\">\n      <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 4.4 6.6\"\n           xml:space=\"preserve\">\n        <path fill=\"none\" stroke=\"#699CD3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n              d=\"M0.8,0.8l2.5,2.5L0.8,5.8\"></path>\n      </svg>\n    </button>\n\n  </div>\n</div>\n";

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"game-view game-view__business-model\">\n\n  <div class=\"action-bar__top visibility-hidden\" data-bm-team-overview-back=\"false\">\n    <div class=\"container\">\n      <button class=\"btn btn-link btn-back back-to-score-btn\" type=\"button\"\n              data-localize=\"serious_game.business_model.back_to_score_btn\"></button>\n    </div>\n  </div>\n\n  <div class=\"business-model-wrapper\">\n    <div class=\"business-model__loader\" style=\"display: none;\">\n      <img src=\"" + __webpack_require__(211) + "\" alt=\"Loading...\"/>\n      <p class=\"loading-text\" data-localize=\"serious_game.business_model.loading\"></p>\n    </div>\n\n    <div class=\"bm__canvas\">\n      <!--Generated-->\n    </div>\n\n    <div class=\"business-model__progress-view\">\n      <!--Generated-->\n    </div>\n  </div>\n\n  <div class=\"action-bar__wrapper\">\n    <div class=\"action-bar action-bar__main\">\n      <div class=\"action-bar__left\">\n        <button class=\"bm-action__data bm-data bm-data__budget\" type=\"button\" data-bm-current-budget=\"0\"\n                disabled=\"disabled\"></button>\n        <button class=\"bm-action__data bm-data bm-data__points\" type=\"button\" data-bm-current-points=\"0\"\n                disabled=\"disabled\"></button>\n      </div>\n\n      <div class=\"action-bar__center\">\n        <button class=\"btn bm-action-btn bm-action-btn__score\" type=\"button\" style=\"display: none;\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24.836\" height=\"17.526\" viewBox=\"0 0 24.836 17.526\">\n            <g transform=\"translate(1 1)\">\n              <rect width=\"7.612\" height=\"7.332\" transform=\"translate(0 8.194)\" fill=\"none\" stroke=\"#fff\"\n                    stroke-miterlimit=\"10\" stroke-width=\"2\"></rect>\n              <rect width=\"7.612\" height=\"9.475\" transform=\"translate(15.224 6.051)\" fill=\"none\" stroke=\"#fff\"\n                    stroke-miterlimit=\"10\" stroke-width=\"2\"></rect>\n              <rect width=\"7.612\" height=\"15.526\" transform=\"translate(7.612)\" fill=\"none\" stroke=\"#fff\"\n                    stroke-miterlimit=\"10\" stroke-width=\"2\"></rect>\n            </g>\n          </svg>\n        </button>\n\n        <button class=\"btn bm-action-btn bm-action-btn__model\" type=\"button\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24.357\" height=\"20.592\" viewBox=\"0 0 24.357 20.592\">\n            <g transform=\"translate(1.119 1)\">\n              <path d=\"M1130.61,1856.516l-.809-7.19h-3.5l-2.092,18.592h7.682\" transform=\"translate(-1124.211 -1849.325)\"\n                    fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"2\"></path>\n              <path\n                d=\"M1150.118,1865.708l-1-2.075-2.174,1.478-.878.6-1-2.075-2.24,1.523-.419.285-.393.267-1-2.075-2.16,1.468-.892.606-1-2.075-3.052,2.075-1.132,10.432h18.479l-1.139-10.432Z\"\n                transform=\"translate(-1129.134 -1857.548)\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\"\n                stroke-width=\"2\"></path>\n              <path d=\"M1172.407,1887.512\" transform=\"translate(-1151.909 -1871.271)\" fill=\"none\" stroke=\"#fff\"\n                    stroke-miterlimit=\"10\" stroke-width=\"2\"></path>\n              <path d=\"M1172.407,1883.707\" transform=\"translate(-1151.909 -1869.084)\" fill=\"none\" stroke=\"#fff\"\n                    stroke-miterlimit=\"10\" stroke-width=\"2\"></path>\n            </g>\n          </svg>\n        </button>\n\n        <button class=\"btn btn-lg bm-action-btn bm-action-btn__investments\" type=\"button\">\n          <span class=\"bm-investment-count\"></span>\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26.468\" height=\"26.468\" viewBox=\"0 0 26.468 26.468\">\n            <g transform=\"translate(0 0)\">\n              <line x2=\"26.468\" transform=\"translate(0 13.234)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"\n                    stroke-width=\"4\"></line>\n              <line y2=\"26.468\" transform=\"translate(13.234 0)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"\n                    stroke-width=\"4\"></line>\n            </g>\n          </svg>\n        </button>\n\n        <button class=\"btn bm-action-btn bm-action-btn__faq\" type=\"button\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24.475\" height=\"35.494\" viewBox=\"0 0 24.475 35.494\">\n            <g transform=\"translate(-719.172 -635.276)\">\n              <g transform=\"translate(720.172 652.624)\">\n                <path d=\"M1564.236,1880.438s-5.618-3.4-11.237-3.4v-13.747a19.8,19.8,0,0,1,11.237,3.4Z\"\n                      transform=\"translate(-1552.999 -1863.291)\" fill=\"none\" stroke=\"#fff\" stroke-linejoin=\"round\"\n                      stroke-width=\"2\"></path>\n                <path d=\"M1582.194,1880.438s5.619-3.4,11.238-3.4v-13.747a19.8,19.8,0,0,0-11.238,3.4Z\"\n                      transform=\"translate(-1570.957 -1863.291)\" fill=\"none\" stroke=\"#fff\" stroke-linejoin=\"round\"\n                      stroke-width=\"2\"></path>\n              </g>\n              <text transform=\"translate(720.172 635.276)\" fill=\"#fff\" font-size=\"16\" font-family=\"Rubik-Bold, Rubik\"\n                    font-weight=\"700\">\n                <tspan x=\"6.461\" y=\"15\">?</tspan>\n              </text>\n            </g>\n          </svg>\n        </button>\n\n        <button class=\"btn bm-action-btn bm-action-btn__event delay-1s slow\" type=\"button\" style=\"display: none;\">\n          <span class=\"bm-event-badge\">!</span>\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23.689\" height=\"31.38\" viewBox=\"0 0 23.689 31.38\">\n            <g transform=\"translate(1.023 1)\">\n              <path\n                d=\"M1761.23,1874.143h-19.991a.824.824,0,0,1-.532-1.454h0a3.724,3.724,0,0,0,1.32-2.844v-5.672a9.207,9.207,0,0,1,9.207-9.207h0a9.208,9.208,0,0,1,9.208,9.207v5.672a3.724,3.724,0,0,0,1.32,2.844h0A.824.824,0,0,1,1761.23,1874.143Z\"\n                transform=\"translate(-1740.413 -1848.081)\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\"\n                stroke-width=\"2\"></path>\n              <path d=\"M1762.86,1895.375a3.318,3.318,0,0,1-6.636,0\" transform=\"translate(-1748.721 -1869.313)\"\n                    fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"2\"></path>\n              <circle cx=\"2.036\" cy=\"2.036\" r=\"2.036\" transform=\"translate(8.786)\" fill=\"none\" stroke=\"#fff\"\n                      stroke-miterlimit=\"10\" stroke-width=\"2\"></circle>\n              <line y1=\"2.814\" transform=\"translate(10.821 4.071)\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\"\n                    stroke-width=\"2\"></line>\n            </g>\n          </svg>\n        </button>\n      </div>\n\n      <div class=\"action-bar__right\">\n        <button class=\"btn bm-action-btn bm-action-btn__loan\" type=\"button\" style=\"display: none;\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 26.5 31.4\"\n               enable-background=\"new 0 0 26.5 31.4\" xml:space=\"preserve\">\n            <path fill=\"#FFFFFF\" stroke=\"#FFFFFF\" stroke-width=\"0.75\" stroke-miterlimit=\"10\" d=\"M7.8,15.9c0.1,0,0.2,0,0.3-0.1\n              c-0.5-0.6-0.8-1.5-0.7-2.4c0.2-1.8,1.8-3.1,3.6-2.9c1.8,0.2,3.1,1.8,2.9,3.6c-0.1,0.6-0.3,1.2-0.6,1.6c0.1,0,0.2,0,0.2,0.1\n              c0.1,0,0.1,0.1,0.2,0.1c0.4-0.5,0.6-1.1,0.7-1.8c0.2-2-1.3-3.9-3.3-4.1c-2-0.2-3.9,1.3-4.1,3.3c-0.1,1,0.2,1.9,0.7,2.6\n              C7.7,16,7.7,15.9,7.8,15.9z\"></path>\n            <path fill=\"#FFFFFF\" d=\"M4.6,29.4c0.2,0.4,0.7,0.7,1.2,0.7c0.2,0,0.5-0.1,0.7-0.2l2.4-1.3c0.3-0.2,0.5-0.4,0.6-0.8c0,0,0,0,0-0.1\n              c0.1-0.3,0.1-0.7-0.1-1h7.9c3.1,0,8.3-6.5,9.1-9.3c0,0,0-0.1,0-0.1c0.2-0.8,0-1.2-0.2-1.5c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0\n              c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.7-0.1-1,0c-1.4,0.3-2.5,1.7-3.3,2.7c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.2-0.4,0.5-0.6,0.7\n              c-0.1-0.1-0.2-0.2-0.3-0.3c0,0-0.1,0-0.1-0.1c-1-0.8-2.7-0.6-3.7-0.5c-0.2,0-0.4,0.1-0.6,0.1c-1.4,0-2.3-0.3-3.2-0.6\n              c-0.9-0.3-1.7-0.5-2.8-0.5c-0.2,0-0.4,0-0.7,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.5,0.2-0.8,0.3c-0.1,0.1-0.2,0.1-0.3,0.2\n              c-0.3,0.2-0.7,0.4-1,0.7c-0.5,0.3-0.9,0.7-1.2,1l-0.3-0.5c-0.1-0.2-0.2-0.3-0.3-0.4c-0.4-0.3-1-0.4-1.5-0.1l-2.4,1.3\n              c-0.7,0.4-0.9,1.2-0.5,1.9L4.6,29.4z M3.2,20.1l0.4-0.2L4.3,21l0,0l0.8,1.4l1.3,2.3l0.6,1.1l0.4,0.8l0.4,0.7l-0.7,0.4l-1.4,0.8\n              L1.6,21L3.2,20.1z M9.1,18.6C9.1,18.6,9.1,18.6,9.1,18.6c0.6-0.1,1-0.1,1.4,0c0.5,0.1,0.9,0.2,1.4,0.4c0.9,0.3,2,0.6,3.6,0.6\n              c0.2,0,0.4,0,0.8-0.1c0.7-0.1,1.9-0.3,2.5,0.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.4c-0.2,0.1-0.3,0.3-0.5,0.4\n              c-0.3,0.2-0.7,0.4-1.1,0.6c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1,0l-3.9,0l0,0.6l0,0.9\n              c0.1,0,2.6,0.1,4.1,0c0.4,0,0.8-0.1,1.2-0.2c0.6-0.2,1.1-0.4,1.6-0.7c0.7-0.5,1.1-0.9,1.1-1l0.2-0.2v0c0.2-0.2,0.4-0.5,0.6-0.7\n              c0.2-0.3,0.4-0.5,0.6-0.7c0-0.1,0.1-0.1,0.1-0.2c1.3-1.7,2.2-2.3,2.8-2.2c0,0,0,0,0.1,0c0,0.2-0.1,0.4-0.3,0.7\n              c-0.3,0.7-0.9,1.7-1.7,2.8c-0.3,0.4-0.7,0.9-1.1,1.4c-1.8,2.1-3.6,3.5-4.6,3.5H8.5l-0.6-1.1l-1.3-2.4l-0.5-1\n              c0.5-0.4,1.1-0.9,1.7-1.3c0.4-0.3,0.7-0.5,1.1-0.7C8.9,18.7,9,18.7,9.1,18.6z\"></path>\n            <circle fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"1.2\" stroke-miterlimit=\"10\" cx=\"21\" cy=\"10.7\"\n                    r=\"3.2\"></circle>\n            <circle fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"1.2\" stroke-miterlimit=\"10\" cx=\"13.3\" cy=\"3.9\"\n                    r=\"3.3\"></circle>\n          </svg>\n        </button>\n\n        <button class=\"btn bm-action-btn bm-action-btn__close-round\" type=\"button\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22.091\" height=\"15.8\" viewBox=\"0 0 22.091 15.8\">\n            <path d=\"M9.509,15.8,0,6.291,3.072,3.219,9.509,9.509,19.019,0l3.072,3.072Z\" transform=\"translate(0 0)\"\n                  fill=\"#0a2b30\"></path>\n          </svg>\n        </button>\n      </div>\n    </div>\n\n    <div class=\"action-bar action-bar__preview\" style=\"display: none;\">\n      <div class=\"action-bar__left\">\n        <div class=\"bm-data__group\">\n          <div class=\"bm-data bm-data__budget bm-preview__budget-current\" data-bm-current-budget=\"0\"></div>\n          <div class=\"bm-data bm-data__points bm-preview__points-current\" data-bm-current-points=\"0\"></div>\n\n          <div class=\"bm-data__connector\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12.043\" height=\"8.167\" viewBox=\"0 0 12.043 8.167\">\n              <g transform=\"translate(-40.457 -127.5)\">\n                <path d=\"M-1728.005,1797.938l3.083,3.083-3.083,3.083\"\n                      transform=\"translate(-1683.051 1932.604) rotate(180)\" fill=\"none\" stroke=\"#0a2b30\"\n                      stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\"></path>\n                <line x2=\"9\" transform=\"translate(42.5 131.5)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n                      stroke-width=\"2\"></line>\n              </g>\n            </svg>\n          </div>\n\n          <div class=\"bm-data bm-data__budget bm-preview__budget-result\" data-bm-preview-budget=\"0\"></div>\n          <div class=\"bm-data bm-data__points bm-preview__points-result\" data-bm-preview-points=\"0\"></div>\n        </div>\n      </div>\n\n      <div class=\"action-bar__right\">\n        <button class=\"btn btn-c-light-blue btn-lg close-preview-btn\" type=\"button\"\n                data-localize=\"serious_game.business_model.actions.close_preview\"></button>\n      </div>\n    </div>\n\n    <div class=\"action-bar action-bar__faq\" style=\"display: none;\">\n      <div class=\"action-bar__right\">\n        <button class=\"btn btn-c-light-blue btn-lg show-tutorial-btn\" type=\"button\"\n                data-localize=\"serious_game.business_model.actions.show_tutorial\"></button>\n        <button class=\"btn btn-c-light-blue btn-lg close-faq-btn\" type=\"button\"\n                data-localize=\"serious_game.business_model.actions.close_faq\"></button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"bm__score-screen\" style=\"display: none;\">\n    <!--Generated-->\n  </div>\n\n  <div class=\"bm__investment-slider\" style=\"display: none;\">\n    <!--generated-->\n  </div>\n\n</div>\n";

/***/ }),

/***/ 797:
/***/ (function(module, exports) {

	module.exports = "<div class=\"game-view game-view__introduction\">\n  <div class=\"container\">\n    <div class=\"content\">\n\n      <div class=\"actions-wrapper\">\n        <button class=\"btn btn-link btn-next skip-intro-btn float-right\" type=\"button\"\n                data-localize=\"serious_game.introduction.skip_btn\"></button>\n      </div>\n\n      <div class=\"introduction-video embed-responsive embed-responsive-16by9\"></div>\n    </div>\n  </div>\n</div>\n";

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"game-view game-view__quiz\">\n  <div class=\"container\">\n    <div class=\"content\">\n\n      <div class=\"questions-wrapper\">\n\n      </div>\n\n      <div class=\"quiz-waiting__loader\" style=\"display: none;\">\n        <img src=\"" + __webpack_require__(211) + "\" alt=\"Loading...\"/>\n        <p class=\"loading-text\" data-localize=\"serious_game.quiz.waiting\"></p>\n      </div>\n\n      <div class=\"quiz-result-wrapper\" style=\"display: none;\">\n        <!--Generated-->\n      </div>\n\n    </div>\n  </div>\n</div>\n";

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"game-view game-view__reconnect\">\n  <div class=\"container\">\n    <div class=\"content\">\n\n      <div class=\"panel panel__user-icon panel__reconnect\">\n        <h4 class=\"panel__title\" data-localize=\"serious_game.reconnect.title\"></h4>\n\n        <p class=\"panel__text\" data-localize=\"serious_game.reconnect.intro_text\"></p>\n\n        <div class=\"reconnect-loader\">\n          <img src=\"" + __webpack_require__(211) + "\" alt=\"Loading...\"/>\n          <div class=\"loading-text\" data-localize=\"serious_game.reconnect.loading.text\"></div>\n        </div>\n\n        <p class=\"reconnect-result my-5 text-danger text-center\" style=\"display: none;\"\n           data-localize=\"serious_game.reconnect.failed.text\"></p>\n\n        <button class=\"btn btn-c-light-blue btn-lg btn-block mt-5 cancel-reconnect-btn\" type=\"button\"\n                data-localize=\"serious_game.reconnect.cancel_btn\"></button>\n      </div>\n\n    </div>\n  </div>\n</div>\n";

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"game-view game-view__session-join\">\n  <div class=\"container\">\n    <div class=\"content\">\n\n      <div class=\"panel panel__user-icon panel__session-join\">\n        <div class=\"join-session-form-wrapper\">\n          <h4 class=\"panel__title\" data-localize=\"serious_game.session.title\"></h4>\n\n          <p class=\"panel__text\" data-localize=\"serious_game.session.intro_text\"></p>\n\n          <form class=\"join-session-form\">\n            <div class=\"form-group\">\n              <label for=\"session-id-input\" data-localize=\"serious_game.session.form.session_id.input\"></label>\n              <input id=\"session-id-input\" class=\"form-control form-control-lg\" type=\"text\"\n                     data-localize=\"serious_game.session.form.session_id.placeholder\" data-fv-name=\"session-id\"/>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"session-name-input\" data-localize=\"serious_game.session.form.session_name.input\"></label>\n              <input id=\"session-name-input\" class=\"form-control form-control-lg\" type=\"text\"\n                     data-localize=\"serious_game.session.form.session_name.placeholder\" data-fv-name=\"team-name\"/>\n            </div>\n\n            <div class=\"form-errors\">\n\n            </div>\n\n            <button class=\"btn btn-c-light-blue btn-lg btn-block mt-5 join-session-btn\" type=\"button\"\n                    data-localize=\"serious_game.session.form.join_btn\"></button>\n          </form>\n\n          <div class=\"join-session-loading-wrapper\">\n            <img src=\"" + __webpack_require__(211) + "\" alt=\"Loading...\"/>\n            <p class=\"loading-text\" data-localize=\"serious_game.session.form.waiting\"></p>\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n";

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<header>\n  <div class=\"container\">\n    <div class=\"header-row\">\n      <div class=\"flex-left\">\n        <a id=\"header-circonopoly-brand\" class=\"navbar-brand\" href=\"#\">\n          <img src=\"" + __webpack_require__(450) + "\" alt=\"Grow Talent\"/>\n          <img src=\"" + __webpack_require__(451) + "\" alt=\"Circonopoly\"/>\n        </a>\n      </div>\n\n      <h3 id=\"page-title\" class=\"header-title center\" data-localize=\"serious_game.page_title.default\"></h3>\n\n      <div class=\"flex-right\">\n        <div id=\"rounds-breadcrumb\" class=\"round-breadcrumb__wrapper\" style=\"display: none;\">\n          <div class=\"breadcrumb__label\"></div>\n          <ol class=\"round-breadcrumb\">\n            <li class=\"round-breadcrumb__item\">1</li>\n            <li class=\"round-breadcrumb__item\">2</li>\n            <li class=\"round-breadcrumb__item\">3</li>\n            <li class=\"round-breadcrumb__item\">4</li>\n            <li class=\"round-breadcrumb__item\">5</li>\n          </ol>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n";

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\n     y=\"0px\"\n     viewBox=\"0 0 26.5 31.4\" enable-background=\"new 0 0 26.5 31.4\" xml:space=\"preserve\">\n<path fill=\"#FFFFFF\" stroke=\"#FFFFFF\" stroke-width=\"0.75\" stroke-miterlimit=\"10\" d=\"M7.8,15.9c0.1,0,0.2,0,0.3-0.1\n\tc-0.5-0.6-0.8-1.5-0.7-2.4c0.2-1.8,1.8-3.1,3.6-2.9c1.8,0.2,3.1,1.8,2.9,3.6c-0.1,0.6-0.3,1.2-0.6,1.6c0.1,0,0.2,0,0.2,0.1\n\tc0.1,0,0.1,0.1,0.2,0.1c0.4-0.5,0.6-1.1,0.7-1.8c0.2-2-1.3-3.9-3.3-4.1c-2-0.2-3.9,1.3-4.1,3.3c-0.1,1,0.2,1.9,0.7,2.6\n\tC7.7,16,7.7,15.9,7.8,15.9z\"/>\n  <path fill=\"#FFFFFF\" d=\"M4.6,29.4c0.2,0.4,0.7,0.7,1.2,0.7c0.2,0,0.5-0.1,0.7-0.2l2.4-1.3c0.3-0.2,0.5-0.4,0.6-0.8c0,0,0,0,0-0.1\n\tc0.1-0.3,0.1-0.7-0.1-1h7.9c3.1,0,8.3-6.5,9.1-9.3c0,0,0-0.1,0-0.1c0.2-0.8,0-1.2-0.2-1.5c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0\n\tc-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.7-0.1-1,0c-1.4,0.3-2.5,1.7-3.3,2.7c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.2-0.4,0.5-0.6,0.7\n\tc-0.1-0.1-0.2-0.2-0.3-0.3c0,0-0.1,0-0.1-0.1c-1-0.8-2.7-0.6-3.7-0.5c-0.2,0-0.4,0.1-0.6,0.1c-1.4,0-2.3-0.3-3.2-0.6\n\tc-0.9-0.3-1.7-0.5-2.8-0.5c-0.2,0-0.4,0-0.7,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.5,0.2-0.8,0.3c-0.1,0.1-0.2,0.1-0.3,0.2\n\tc-0.3,0.2-0.7,0.4-1,0.7c-0.5,0.3-0.9,0.7-1.2,1l-0.3-0.5c-0.1-0.2-0.2-0.3-0.3-0.4c-0.4-0.3-1-0.4-1.5-0.1l-2.4,1.3\n\tc-0.7,0.4-0.9,1.2-0.5,1.9L4.6,29.4z M3.2,20.1l0.4-0.2L4.3,21l0,0l0.8,1.4l1.3,2.3l0.6,1.1l0.4,0.8l0.4,0.7l-0.7,0.4l-1.4,0.8\n\tL1.6,21L3.2,20.1z M9.1,18.6C9.1,18.6,9.1,18.6,9.1,18.6c0.6-0.1,1-0.1,1.4,0c0.5,0.1,0.9,0.2,1.4,0.4c0.9,0.3,2,0.6,3.6,0.6\n\tc0.2,0,0.4,0,0.8-0.1c0.7-0.1,1.9-0.3,2.5,0.1c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.4c-0.2,0.1-0.3,0.3-0.5,0.4\n\tc-0.3,0.2-0.7,0.4-1.1,0.6c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1,0l-3.9,0l0,0.6l0,0.9\n\tc0.1,0,2.6,0.1,4.1,0c0.4,0,0.8-0.1,1.2-0.2c0.6-0.2,1.1-0.4,1.6-0.7c0.7-0.5,1.1-0.9,1.1-1l0.2-0.2v0c0.2-0.2,0.4-0.5,0.6-0.7\n\tc0.2-0.3,0.4-0.5,0.6-0.7c0-0.1,0.1-0.1,0.1-0.2c1.3-1.7,2.2-2.3,2.8-2.2c0,0,0,0,0.1,0c0,0.2-0.1,0.4-0.3,0.7\n\tc-0.3,0.7-0.9,1.7-1.7,2.8c-0.3,0.4-0.7,0.9-1.1,1.4c-1.8,2.1-3.6,3.5-4.6,3.5H8.5l-0.6-1.1l-1.3-2.4l-0.5-1\n\tc0.5-0.4,1.1-0.9,1.7-1.3c0.4-0.3,0.7-0.5,1.1-0.7C8.9,18.7,9,18.7,9.1,18.6z\"/>\n  <circle fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"1.2\" stroke-miterlimit=\"10\" cx=\"21\" cy=\"10.7\" r=\"3.2\"/>\n  <circle fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"1.2\" stroke-miterlimit=\"10\" cx=\"13.3\" cy=\"3.9\" r=\"3.3\"/>\n</svg>\n"

/***/ }),

/***/ 853:
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"60\" height=\"60\" viewBox=\"0 0 60 60\">\n  <g transform=\"translate(-89.477 -93.723)\" opacity=\"0.996\">\n    <rect width=\"60\" height=\"60\" transform=\"translate(89.477 93.723)\" fill=\"#D6EAD8\" opacity=\"0\"/>\n    <path d=\"M0,0H5.236V24.721H0Z\" transform=\"translate(121.238 116.635)\" fill=\"#59B57D\"/>\n    <path d=\"M121.336,116.631s7.954-1.552,9.722-3.32a4.527,4.527,0,1,0-6.4-6.4c-.76.76-1.479,2.661-2.053,4.582\"\n          transform=\"translate(-2.568 0)\" fill=\"none\" stroke=\"#59B57D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"\n          stroke-width=\"0.76\"/>\n    <g transform=\"translate(94.083 116.269)\">\n      <rect width=\"8.84\" height=\"25.087\" transform=\"translate(5.918)\" fill=\"#59B57D\"/>\n      <rect width=\"2.36\" height=\"25.087\" transform=\"translate(8.737)\" fill=\"#D6EAD8\"/>\n      <path d=\"M138.544,142.505H110.376V117.785h28.168v16.492\" transform=\"translate(-95.618 -117.418)\" fill=\"none\"\n            stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <line y2=\"5.183\" transform=\"translate(42.926 19.903)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n            stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <path d=\"M0,0H50.12\" transform=\"translate(0 25.087)\" fill=\"none\" stroke=\"#59B57D\" stroke-linecap=\"round\"\n            stroke-width=\"0.76\"/>\n    </g>\n    <path d=\"M121.428,116.631s-7.953-1.552-9.721-3.32a4.527,4.527,0,0,1,6.4-6.4c1.189,1.19,2.281,5.18,2.868,7.663\"\n          transform=\"translate(-1.535 0)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"\n          stroke-width=\"0.76\"/>\n  </g>\n</svg>\n"

/***/ })

});


// WEBPACK FOOTER //
// js/game.514c88be2e0ec42c9721.js